import {
	BlockResponse,
	BlockType,
	TextBlockData
} from "@/Contracts/ProposalBuilder/Block";
import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import DownloadFile from "downloadjs";
import { extension } from "mime-types";

import { DefaultErrorMessage, ZomentumStorageKeys } from "@/Contracts";
import {
	ChildEntityHydrationParams,
	getQueryParamAuthDetails,
	QueryParamConstants
} from "@/Contracts/Utils";
import {
	Document,
	DocumentCount,
	MailRecipient,
	DocumentsRequest,
	AddDocumentRequest,
	UpdateDocumentCountRequest,
	UpdateBlockListSequenceRequest,
	BlockRepositionRequest,
	DocumentSidePanelEnum,
	EditDocumentRequest,
	CloneDocumentRequest,
	DocumentDetailsRequest,
	DocumentRecipient,
	MergeTagVariable,
	DocumentExpiry,
	EmptyMergeTagResponse,
	DownloadDocumentProductListRequest,
	DocumentPayment,
	ClientPaymentData,
	MergeTagInput,
	DocumentBulkUpdateStatusRequest,
	DocumentsResponse,
	DocumentApprovalSendRequest,
	DocumentApprovalVerdictRequest,
	DocumentPinGenerationRequest,
	DocumentPinVerificationRequest,
	DocumentPinGenerationResponse,
	VerifyDocumentPinResponse,
	MakePaymentPayload,
	ConnectBoosterPaymentRequest,
	UpdatePoDetailsPayload,
	BulkAssignSignatureBlocksRequest,
	PaymentMethod,
	QuickbooksDocumentSyncFormData,
	QuickbooksSyncFormDataParams,
	PaymentSummary,
	UpdateOrderFormPublishStatusRequest,
	DocumentStatus,
	UpdateDocumentLinkStatusRequest,
	DocumentType,
	DownloadDocumentLogsRequest,
	UpdateMultipleBlockListSequenceRequest
} from "@/Contracts/Documents";
import { AutotaskProductValidationView } from "@/Contracts/Documents";

import {
	getDocuments,
	getDocumentDetails,
	updateDocumentPaymentSettings,
	startConnectBoosterPayment,
	cbPayment,
	deleteDocument,
	addDocument,
	editDocument,
	downloadDocument,
	getMailRecipients,
	updateRevisionBlockList,
	getDocumentDetailsFromClient,
	downloadDocumentFromClient,
	approveDocument,
	cancelSignatureFromClient,
	assignSignatureBlockToRecipient,
	reorderSigners,
	renewCurrentActiveDocument,
	editRevision,
	getEmptyMergeTags,
	validateAutotaskItems,
	downloadDocumentProductList,
	getDocumentPaymentStatusCB,
	updateClientPaymentDetails,
	updateMergeTagsByValue,
	documentBulkUpdate,
	getAllDocumentViews,
	getDocumentViewMetadata,
	getDocumentListPost,
	createDocumentView,
	updateDocumentView,
	deleteDocumentView,
	bulkDeleteDocumentRecords,
	bulkUpdateRecords,
	sendDocumentApprovalRequest,
	sendDocumentApprovalVerdict,
	fetchDocumentApprovalStatus,
	sendDocumentPin,
	verifyDocumentPin,
	makeConnectBoosterPayment,
	updatePoDetails,
	bulkAssignSignatureBlocks,
	createCheckoutSession,
	getQuickbooksSyncMetadata,
	quickbooksFormSyncData,
	getQuickbooksCustomers,
	expireCurrentStripeCheckoutSession,
	updateOrderFormPublishStatus,
	updateDocumentStatusLink,
	downloadDocumentLogs
} from "@/Services/Documents";
import { getBlockList, addBlock } from "@/ProposalBuilder/services/Block";

import BlocksActionCreators, {
	BlocksActionTypes,
	GetBlockMapperSuccessfulAction,
	GetBlockMapperRequestedAction,
	GetBlockMapperFailedAction,
	CreateBlockRequestedAction,
	CreateBlockSuccessfulAction
} from "@/ProposalBuilder/store/actions/Blocks";
import {
	BlockMapper,
	Block,
	createNewBlock,
	draggableIdToBlockTypeMapper
} from "@/Contracts/ProposalBuilder/Block";
import { cache } from "@/Contracts";
import {
	ApprovalDetails,
	ApprovalStatusResponse,
	DocumentDefaults,
	DocumentRevision
} from "@/Contracts/Documents/Revision";
import { updateMergeTagsDisplayName } from "@/Utils/MergeTags";
import {
	CustomViewsMetadata,
	CustomViewResponse,
	CustomView,
	ListPagePostRequest,
	BulkDeleteRecordsRequest,
	BulkUpdateRecordsRequest
} from "@/Contracts/UI";
import { CommonNameValuePair } from "@/Contracts/Settings";
import { GlobalState } from "@/Reducers/interface";
import { updateGOFDocumentData } from "@/Utils/Documents";
import { proposalBuilderStore } from "@/ProposalBuilder/store";
import {
	ParentStateActionTypes,
	UpdateCurrentActiveDocumentAction
} from "@/ProposalBuilder/store/actions/Parent";
import { Gateway } from "@/Contracts";
import { areFiltersChanged } from "@/Utils/common";

export const LOADING_BLOCK_PLACEHOLDER = "LOADING_BLOCK";

export enum DocumentsActionTypes {
	SHOW_DOCUMENTS_LOADER = "SHOW_DOCUMENTS_LOADER",
	HIDE_DOCUMENTS_LOADER = "HIDE_DOCUMENTS_LOADER",
	DOCUMENTS_REQUESTED = "DOCUMENTS_REQUESTED",
	DOCUMENTS_SUCCESSFUL = "DOCUMENTS_SUCCESSFUL",
	DOCUMENTS_FAILED = "DOCUMENTS_FAILED",
	DOCUMENT_DETAILS_UPDATED = "DOCUMENT_DETAILS_UPDATED",
	DOCUMENTS_RESET = "DOCUMENTS_RESET",
	DOCUMENT_DETAILS_REQUESTED = "DOCUMENT_DETAILS_REQUESTED",
	DOCUMENT_DETAILS_SUCCESSFUL = "DOCUMENT_DETAILS_SUCCESSFUL",
	DOCUMENT_DETAILS_FAILED = "DOCUMENT_DETAILS_FAILED",
	UPDATE_DOCUMENT_PAYMENT_REQUESTED = "UPDATE_DOCUMENT_PAYMENT_REQUESTED",
	UPDATE_DOCUMENT_PAYMENT_SUCCESSFUL = "UPDATE_DOCUMENT_PAYMENT_SUCCESSFUL",
	UPDATE_DOCUMENT_PAYMENT_FAILED = "UPDATE_DOCUMENT_PAYMENT_FAILED",
	DOCUMENT_PAYMENT_STATUS_REQUESTED = "DOCUMENT_PAYMENT_STATUS_REQUESTED",
	DOCUMENT_PAYMENT_STATUS_SUCCESSFUL = "DOCUMENT_PAYMENT_STATUS_SUCCESSFUL",
	DOCUMENT_PAYMENT_STATUS_FAILED = "DOCUMENT_PAYMENT_STATUS_FAILED",
	// Will be Depreceated --start
	START_DOCUMENT_PAYMENT_REQUESTED = "START_DOCUMENT_PAYMENT_REQUESTED",
	START_DOCUMENT_PAYMENT_SUCCESSFUL = "START_DOCUMENT_PAYMENT_SUCCESSFUL",
	START_DOCUMENT_PAYMENT_FAILED = "START_DOCUMENT_PAYMENT_FAILED",
	// Will be Depreceated --end
	UPDATE_CLIENT_DOCUMENT_PAYMENT_REQUESTED = "UPDATE_CLIENT_DOCUMENT_PAYMENT_REQUESTED",
	UPDATE_CLIENT_DOCUMENT_PAYMENT_SUCCESSFUL = "UPDATE_CLIENT_DOCUMENT_PAYMENT_SUCCESSFUL",
	UPDATE_CLIENT_DOCUMENT_PAYMENT_FAILED = "UPDATE_CLIENT_DOCUMENT_PAYMENT_FAILED",
	DOCUMENT_PAYMENT_REQUESTED = "DOCUMENT_PAYMENT_REQUESTED",
	DOCUMENT_PAYMENT_SUCCESSFUL = "DOCUMENT_PAYMENT_SUCCESSFUL",
	DOCUMENT_PAYMENT_FAILED = "DOCUMENT_PAYMENT_FAILED",
	DOCUMENT_DETAILS_RESET = "DOCUMENT_DETAILS_RESET",
	DELETE_DOCUMENT_REQUESTED = "DELETE_DOCUMENT_REQUESTED",
	DELETE_DOCUMENT_SUCCESSFUL = "DELETE_DOCUMENT_SUCCESSFUL",
	DELETE_DOCUMENT_FAILED = "DELETE_DOCUMENT_FAILED",
	ADD_DOCUMENT_REQUESTED = "ADD_DOCUMENT_REQUESTED",
	ADD_DOCUMENT_SUCCESSFUL = "ADD_DOCUMENT_SUCCESSFUL",
	ADD_DOCUMENT_FAILED = "ADD_DOCUMENT_FAILED",
	CLONE_DOCUMENT_REQUESTED = "CLONE_DOCUMENT_REQUESTED",
	CLONE_DOCUMENT_SUCCESSFUL = "CLONE_DOCUMENT_SUCCESSFUL",
	CLONE_DOCUMENT_FAILED = "CLONE_DOCUMENT_FAILED",
	EDIT_DOCUMENT_REQUESTED = "EDIT_DOCUMENT_REQUESTED",
	EDIT_DOCUMENT_SUCCESSFUL = "EDIT_DOCUMENT_SUCCESSFUL",
	EDIT_DOCUMENT_FAILED = "EDIT_DOCUMENT_FAILED",
	DOWNLOAD_DOCUMENT_REQUESTED = "DOWNLOAD_DOCUMENT_REQUESTED",
	DOWNLOAD_DOCUMENT_SUCCESSFUL = "DOWNLOAD_DOCUMENT_SUCCESSFUL",
	DOWNLOAD_DOCUMENT_FAILED = "DOWNLOAD_DOCUMENT_FAILED",
	UPDATE_DOCUMENT_COUNT = "UPDATE_DOCUMENT_COUNT",
	RESET_DOCUMENT_COUNT = "RESET_DOCUMENT_COUNT",
	MAIL_RECIPIENTS_REQUESTED = "MAIL_RECIPIENTS_REQUESTED",
	MAIL_RECIPIENTS_SUCCESSFUL = "MAIL_RECIPIENTS_SUCCESSFUL",
	MAIL_RECIPIENTS_FAILED = "MAIL_RECIPIENTS_FAILED",
	MAIL_RECIPIENTS_RESET = "MAIL_RECIPIENTS_RESET",
	DOWNLOAD_DOCUMENT_MODAL_OPENED = "DOWNLOAD_DOCUMENT_MODAL_OPENED",
	DOWNLOAD_DOCUMENT_MODAL_CLOSED = "DOWNLOAD_DOCUMENT_MODAL_CLOSED",
	EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_CLOSED = "EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_CLOSED",
	EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_OPENED = "EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_OPENED",
	ADD_DOCUMENT_DRAWER_OPENED = "ADD_DOCUMENT_DRAWER_OPENED",
	ADD_DOCUMENT_DRAWER_CLOSED = "ADD_DOCUMENT_DRAWER_CLOSED",
	EDIT_OR_CLONE_DOCUMENT_DRAWER_OPENED = "EDIT_DOCUMENT_DRAWER_OPENED",
	EDIT_OR_CLONE_DOCUMENT_DRAWER_CLOSED = "EDIT_DOCUMENT_DRAWER_CLOSED",
	SEND_DOCUMENT_DRAWER_OPENED = "SEND_DOCUMENT_DRAWER_OPENED",
	SEND_DOCUMENT_DRAWER_CLOSED = "SEND_DOCUMENT_DRAWER_CLOSED",

	UPDATE_DOCUMENT_REVISION_BLOCK_LIST = "UPDATE_DOCUMENT_REVISION_BLOCK_LIST",
	UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED = "UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED",
	SET_DOCUMENT_SIDE_PANEL = "SET_DOCUMENT_SIDE_PANEL",
	UPDATE_CURRENT_DOCUMENT_REQUESTED = "UPDATE_CURRENT_DOCUMENT_REQUESTED",
	UPDATE_CURRENT_DOCUMENT_SUCCESSFUL = "UPDATE_CURRENT_DOCUMENT_SUCCESSFUL",

	RENEW_CURRENT_DOCUMENT_REQUESTED = "RENEW_CURRENT_DOCUMENT_REQUESTED",
	RENEW_CURRENT_DOCUMENT_SUCCESSFUL = "RENEW_CURRENT_DOCUMENT_SUCCESSFUL",
	RENEW_CURRENT_DOCUMENT_FAILED = "RENEW_CURRENT_DOCUMENT_FAILED",

	UPDATE_CURRENT_DOCUMENT_FAILED = "UPDATE_CURRENT_DOCUMENT_FAILED",
	CREATE_TEMPLATE_FROM_DOCUMENT_REQUESTED = "CREATE_TEMPLATE_FROM_DOCUMENT_REQUESTED",
	CREATE_TEMPLATE_FROM_DOCUMENT_SUCCESSFUL = "CREATE_TEMPLATE_FROM_DOCUMENT_SUCCESSFUL",
	CREATE_TEMPLATE_FROM_DOCUMENT_FAILED = "CREATE_TEMPLATE_FROM_DOCUMENT_FAILED",

	CANCEL_SIGNATURE_FROM_DOCUMENT_REQUESTED = "CANCEL_SIGNATURE_FROM_DOCUMENT_REQUESTED",
	CANCEL_SIGNATURE_FROM_DOCUMENT_SUCCESSFUL = "CANCEL_SIGNATURE_FROM_DOCUMENT_SUCCESSFUL",
	CANCEL_SIGNATURE_FROM_DOCUMENT_FAILED = "CANCEL_SIGNATURE_FROM_DOCUMENT_FAILED",

	ASSIGN_SIGNATURE_BLOCK_TO_RECIPIENT_REQUESTED = "ASSIGN_SIGNATURE_BLOCK_TO_RECIPIENT_REQUESTED",

	DOWNLOAD_DOCUMENT_PRODUCT_LIST_REQUESTED = "DOWNLOAD_DOCUMENT_PRODUCT_LIST_REQUESTED",
	DOWNLOAD_DOCUMENT_PRODUCT_LIST_SUCCESSFUL = "DOWNLOAD_DOCUMENT_PRODUCT_LIST_SUCCESSFUL",
	DOWNLOAD_DOCUMENT_PRODUCT_LIST_FAILED = "DOWNLOAD_DOCUMENT_PRODUCT_LIST_FAILED",

	UPDATE_MERGE_TAGS_VALUE_REQUESTED = "UPDATE_MERGE_TAGS_VALUE_REQUESTED",
	UPDATE_MERGE_TAGS_VALUE_SUCCESSFUL = "UPDATE_MERGE_TAGS_VALUE_SUCCESSFUL",
	UPDATE_MERGE_TAGS_VALUE_FAILED = "UPDATE_MERGE_TAGS_VALUE_FAILED",

	SHOW_SIGN_FLOW_CONFIRMATION_MODAL = "SHOW_SIGN_FLOW_CONFIRMATION_MODAL",
	HIDE_SIGN_FLOW_CONFIRMATION_MODAL = "HIDE_SIGN_FLOW_CONFIRMATION_MODAL",

	SHOW_PUSH_CHANGES_TO_PSA_MODAL = "SHOW_PUSH_CHANGES_TO_PSA_MODAL",
	HIDE_PUSH_CHANGES_TO_PSA_MODAL = "HIDE_PUSH_CHANGES_TO_PSA_MODAL",

	// Drawers
	OPEN_ADD_DOCUMENT_PRODUCT_CATALOG_DRAWER = "OPEN_ADD_DOCUMENT_PRODUCT_CATALOG_DRAWER",
	CLOSE_ADD_DOCUMENT_PRODUCT_CATALOG_DRAWER = "CLOSE_ADD_DOCUMENT_PRODUCT_CATALOG_DRAWER",
	OPEN_EDIT_DOCUMENT_PRODUCT_CATALOG_DRAWER = "OPEN_EDIT_DOCUMENT_PRODUCT_CATALOG_DRAWER",
	CLOSE_EDIT_DOCUMENT_PRODUCT_CATALOG_DRAWER = "CLOSE_EDIT_DOCUMENT_PRODUCT_CATALOG_DRAWER",
	OPEN_SEARCH_DOCUMENT_PRODUCT_CATALOG_DRAWER = "OPEN_SEARCH_DOCUMENT_PRODUCT_CATALOG_DRAWER",
	CLOSE_SEARCH_DOCUMENT_PRODUCT_CATALOG_DRAWER = "CLOSE_SEARCH_DOCUMENT_PRODUCT_CATALOG_DRAWER",

	UPDATE_DOCUMENT_DEFAULTS_REQUESTED = "UPDATE_DOCUMENT_DEFAULTS_REQUESTED",
	UPDATE_DOCUMENT_DEFAULTS_SUCCESSFUL = "UPDATE_DOCUMENT_DEFAULTS_SUCCESSFUL",
	UPDATE_DOCUMENT_DEFAULTS_FAILED = "UPDATE_DOCUMENT_DEFAULTS_FAILED",

	// Merge tag actions
	UPDATE_MERGE_TAG_REQUESTED = "UPDATE_MERGE_TAG_REQUESTED",
	UPDATE_MERGE_TAG_SUCCESSFUL = "UPDATE_MERGE_TAG_SUCCESSFUL",
	UPDATE_MERGE_TAG_FAILED = "UPDATE_MERGE_TAG_FAILED",

	FETCH_EMPTY_MERGE_TAGS_REQUESTED = "FETCH_EMPTY_MERGE_TAGS_REQUESTED",
	FETCH_EMPTY_MERGE_TAGS_SUCCESSFUL = "FETCH_EMPTY_MERGE_TAGS_SUCCESSFUL",
	FETCH_EMPTY_MERGE_TAGS_FAILED = "FETCH_EMPTY_MERGE_TAGS_FAILED",

	VALIDATE_AUTOTASK_ITEMS_REQUESTED = "VALIDATE_AUTOTASK_ITEMS_REQUESTED",
	VALIDATE_AUTOTASK_ITEMS_SUCCESSFUL = "VALIDATE_AUTOTASK_ITEMS_SUCCESSFUL",
	VALIDATE_AUTOTASK_ITEMS_FAILED = "VALIDATE_AUTOTASK_ITEMS_FAILED",

	DOCUMENT_LINK_COPIED_STATUS_UPDATE_REQUESTED = "DOCUMENT_LINK_COPIED_STATUS_UPDATE_REQUESTED",
	DOCUMENT_LINK_COPIED_STATUS_UPDATE_SUCCESSFUL = "DOCUMENT_LINK_COPIED_STATUS_UPDATE_SUCCESSFUL",
	DOCUMENT_LINK_COPIED_STATUS_UPDATE_FAILED = "DOCUMENT_LINK_COPIED_STATUS_UPDATE_FAILED",

	// Input field actions
	ADD_INPUT_FIELD_MODAL_OPENED = "ADD_INPUT_FIELD_MODAL_OPENED",
	ADD_INPUT_FIELD_MODAL_CLOSED = "ADD_INPUT_FIELD_MODAL_CLOSED",

	DOCUMENT_BULK_UPDATE_STATUS_REQUESTED = "DOCUMENT_BULK_UPDATE_STATUS_REQUESTED",
	DOCUMENT_BULK_UPDATE_STATUS_SUCCESSFUL = "DOCUMENT_BULK_UPDATE_STATUS_SUCCESSFUL",
	DOCUMENT_BULK_UPDATE_STATUS_FAILED = "DOCUMENT_BULK_UPDATE_STATUS_FAILED",

	// Document Side Panel actions
	OPEN_DOCUMENT_SIDE_PANEL = "OPEN_DOCUMENT_SIDE_PANEL",
	CLOSE_DOCUMENT_SIDE_PANEL = "CLOSE_DOCUMENT_SIDE_PANEL",

	// FILTERS AND VIEWS

	FETCH_DOCUMENT_VIEW_METADATA_REQUESTED = "FETCH_DOCUMENT_VIEW_METADATA_REQUESTED",
	FETCH_DOCUMENT_VIEW_METADATA_SUCCESSFUL = "FETCH_DOCUMENT_VIEW_METADATA_SUCCESSFUL",
	FETCH_DOCUMENT_VIEW_METADATA_FAILED = "FETCH_DOCUMENT_VIEW_METADATA_FAILED",

	FETCH_ALL_DOCUMENT_VIEWS_REQUESTED = "FETCH_ALL_DOCUMENT_VIEWS_REQUESTED",
	FETCH_ALL_DOCUMENT_VIEWS_SUCCESSFUL = "FETCH_ALL_DOCUMENT_VIEWS_SUCCESSFUL",
	FETCH_ALL_DOCUMENT_VIEWS_FAILED = "FETCH_ALL_DOCUMENT_VIEWS_FAILED",

	FETCH_DOCUMENT_LIST_REQUESTED = "FETCH_DOCUMENT_LIST_REQUESTED",
	FETCH_DOCUMENT_LIST_SUCCESSFUL = "FETCH_DOCUMENT_LIST_SUCCESSFUL",
	FETCH_DOCUMENT_LIST_FAILED = "FETCH_DOCUMENT_LIST_FAILED",

	UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW = "UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW",

	CREATE_DOCUMENT_VIEW_REQUESTED = "CREATE_DOCUMENT_VIEW_REQUESTED",
	CREATE_DOCUMENT_VIEW_SUCCESSFUL = "CREATE_DOCUMENT_VIEW_SUCCESSFUL",
	CREATE_DOCUMENT_VIEW_FAILED = "CREATE_DOCUMENT_VIEW_FAILED",

	UPDATE_DOCUMENT_VIEW_REQUESTED = "UPDATE_DOCUMENT_VIEW_REQUESTED",
	UPDATE_DOCUMENT_VIEW_SUCCESSFUL = "UPDATE_DOCUMENT_VIEW_SUCCESSFUL",
	UPDATE_DOCUMENT_VIEW_FAILED = "UPDATE_DOCUMENT_VIEW_FAILED",

	DELETE_DOCUMENT_VIEW_REQUESTED = "DELETE_DOCUMENT_VIEW_REQUESTED",
	DELETE_DOCUMENT_VIEW_SUCCESSFUL = "DELETE_DOCUMENT_VIEW_SUCCESSFUL",
	DELETE_DOCUMENT_VIEW_FAILED = "DELETE_DOCUMENT_VIEW_FAILED",

	BULK_ACTION_RECORDS_SELECTED = "BULK_ACTION_RECORDS_SELECTED",
	BULK_ACTION_RECORDS_RESET = "BULK_ACTION_RECORDS_RESET",

	BULK_DELETE_RECORDS_REQUESTED = "BULK_DELETE_RECORDS_REQUESTED",
	BULK_DELETE_RECORDS_SUCCESSFUL = "BULK_DELETE_RECORDS_SUCCESSFUL",
	BULK_DELETE_RECORDS_FAILED = "BULK_DELETE_RECORDS_FAILED",

	BULK_UPDATE_RECORDS_REQUESTED = "BULK_UPDATE_RECORDS_REQUESTED",
	BULK_UPDATE_RECORDS_SUCCESSFUL = "BULK_UPDATE_RECORDS_SUCCESSFUL",
	BULK_UPDATE_RECORDS_FAILED = "BULK_UPDATE_RECORDS_FAILED",
	RESET_DOCUMENTS_CURRENT_ACTIVE_VIEW = "RESET_DOCUMENTS_CURRENT_ACTIVE_VIEW",

	DOCUMENT_APPROVAL_REQUEST_REQUESTED = "DOCUMENT_APPROVAL_REQUEST_REQUESTED",
	DOCUMENT_APPROVAL_REQUEST_SUCCESSFUL = "DOCUMENT_APPROVAL_REQUEST_SUCCESSFUL",
	DOCUMENT_APPROVAL_REQUEST_FAILED = "DOCUMENT_APPROVAL_REQUEST_FAILED",

	DOCUMENT_APPROVAL_VERDICT_REQUESTED = "DOCUMENT_APPROVAL_VERDICT_REQUESTED",
	DOCUMENT_APPROVAL_VERDICT_SUCCESSFUL = "DOCUMENT_APPROVAL_VERDICT_SUCCESSFUL",
	DOCUMENT_APPROVAL_VERDICT_FAILED = "DOCUMENT_APPROVAL_VERDICT_FAILED",

	DOCUMENT_FETCH_APPROVAL_STATUS_REQUESTED = "DOCUMENT_FETCH_APPROVAL_STATUS_REQUESTED",
	DOCUMENT_FETCH_APPROVAL_STATUS_SUCCESSFUL = "DOCUMENT_FETCH_APPROVAL_STATUS_SUCCESSFUL",
	DOCUMENT_FETCH_APPROVAL_STATUS_FAILED = "DOCUMENT_FETCH_APPROVAL_STATUS_FAILED",

	// Document PIN

	SEND_DOCUMENT_PIN_REQUESTED = "SEND_DOCUMENT_PIN_REQUESTED",
	SEND_DOCUMENT_PIN_SUCCESSFUL = "SEND_DOCUMENT_PIN_SUCCESSFUL",
	SEND_DOCUMENT_PIN_FAILED = "SEND_DOCUMENT_PIN_FAILED",

	VERIFY_DOCUMENT_PIN_REQUESTED = "VERIFY_DOCUMENT_PIN_REQUESTED",
	VERIFY_DOCUMENT_PIN_SUCCESSFUL = "VERIFY_DOCUMENT_PIN_SUCCESSFUL",
	VERIFY_DOCUMENT_PIN_FAILED = "VERIFY_DOCUMENT_PIN_FAILED",

	// Document Payment
	MAKE_PAYMENT_REQUESTED = "MAKE_PAYMENT_REQUESTED",
	MAKE_PAYMENT_SUCCESSFUL = "MAKE_PAYMENT_SUCCESFFUL",
	MAKE_PAYMENT_FAILED = "MAKE_PAYMENT_FAILED",
	UPDATE_PREVIEW_PAYMENT_SUMMARY = "UPDATE_PREVIEW_PAYMENT_SUMMARY",

	// Document po details
	UPDATE_DOCUMENT_PO_DETAILS_REQUESTED = "UPDATE_DOCUMENT_PO_DETAILS_REQUESTED",
	UPDATE_DOCUMENT_PO_DETAILS_SUCCESSFUL = "UPDATE_DOCUMENT_PO_DETAILS_SUCCESSFUL",
	UPDATE_DOCUMENT_PO_DETAILS_FAILED = "UPDATE_DOCUMENT_PO_DETAILS_FAILED",

	// Bulk assign Signature blocks
	BULK_ASSIGN_SIGNATURE_BLOCK_REQUESTED = "BULK_ASSIGN_SIGNATURE_BLOCK_REQUESTED",
	BULK_ASSIGN_SIGNATURE_BLOCK_SUCCESSFUL = "BULK_ASSIGN_SIGNATURE_BLOCK_SUCCESSFUL",
	BULK_ASSIGN_SIGNATURE_BLOCK_FAILED = "BULK_ASSIGN_SIGNATURE_BLOCK_FAILED",

	//Document Stripe payment
	STRIPE_CHECKOUT_SESSION_REQUESTED = "STRIPE_CHECKOUT_SESSION_REQUESTED",
	STRIPE_CHECKOUT_SESSION_SUCCESSFUL = "STRIPE_CHECKOUT_SESSION_SUCCESSFUL",
	STRIPE_CHECKOUT_SESSION_FAILED = "STRIPE_CHECKOUT_SESSION_FAILED",

	//Quickbooks
	QUICKBOOKS_SYNC_DRAWER_OPENED = "QUICKBOOKS_SYNC_DRAWER_OPENED",
	QUICKBOOKS_SYNC_DRAWER_CLOSED = "QUICKBOOKS_SYNC_DRAWER_CLOSED",

	QUICKBOOKS_FORM_METADATA_REQUESTED = "QUICKBOOKS_FORM_METADATA_REQUESTED",
	QUICKBOOKS_FORM_METADATA_SUCCESSFUL = "QUICKBOOKS_FORM_METADATA_SUCCESSFUL",
	QUICKBOOKS_FORM_METADATA_FAILED = "QUICKBOOKS_FORM_METADATA_FAILED",

	QUICKBOOKS_FORMDATA_SYNC_REQUESTED = "QUICKBOOKS_FORMDATA_SYNC_REQUESTED",
	QUICKBOOKS_FORMDATA_SYNC_SUCCESSFUL = "QUICKBOOKS_FORMDATA_SYNC_SUCCESSFUL",
	QUICKBOOKS_FORMDATA_SYNC_FAILED = "QUICKBOOKS_FORMDATA_SYNC_FAILED",

	QUICKBOOKS_CUSTOMERS_REQUESTED = "QUICKBOOKS_CUSTOMERS_REQUESTED",
	QUICKBOOKS_CUSTOMERS_SUCCESSFUL = "QUICKBOOKS_CUSTOMERS_SUCCESSFUL",
	QUICKBOOKS_CUSTOMERS_FAILED = "QUICKBOOKS_CUSTOMERS_FAILED",

	// Update payment summary (total, discount, tax and adjustment fees)
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_REQUESTED = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_REQUESTED",
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL",
	UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_FAILED = "UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_FAILED",

	// Order forms
	UPDATE_ORDER_FORM_PUBLISH_STATUS_REQUESTED = "UPDATE_ORDER_FORM_PUBLISH_STATUS_REQUESTED",
	UPDATE_ORDER_FORM_PUBLISH_STATUS_SUCCESSFUL = "UPDATE_ORDER_FORM_PUBLISH_STATUS_SUCCESSFUL",
	UPDATE_ORDER_FORM_PUBLISH_STATUS_FAILED = "UPDATE_ORDER_FORM_PUBLISH_STATUS_FAILED",

	//Payment(Stripe): Expiration of checkout session
	EXPIRE_CURRENY_CHECKOUT_SESSION_REQUESTED = "EXPIRE_CURRENY_CHECKOUT_SESSION_REQUESTED",
	EXPIRE_CURRENY_CHECKOUT_SESSION_SUCCESSFUL = "EXPIRE_CURRENY_CHECKOUT_SESSION_SUCCESSFUL",
	EXPIRE_CURRENY_CHECKOUT_SESSION_FAILED = "EXPIRE_CURRENY_CHECKOUT_SESSION_FAILED",

	// showing loader on document unmount
	SHOW_DOCUMENTS_UNLOADER = "SHOW_DOCUMENTS_UNLOADER",
	HIDE_DOCUMENTS_UNLOADER = "HIDE_DOCUMENTS_UNLOADER",

	UPDATE_DOCUMENT_LINK_STATUS_SUCCESSFULL = "UPDATE_DOCUMENT_LINK_STATUS_SUCCESSFULL",

	DOWNLOAD_DOCUMENT_LOGS_REQUESTED = "DOWNLOAD_DOCUMENT_LOGS_REQUESTED",
	DOWNLOAD_DOCUMENT_LOGS_SUCCESSFUL = "DOWNLOAD_DOCUMENT_LOGS_SUCCESSFUL",
	DOWNLOAD_DOCUMENT_LOGS_FAILED = "DOWNLOAD_DOCUMENT_LOGS_FAILED",

	// preview document modal
	SHOW_PREVIEW_DOCUMENT_MODAL = "SHOW_PREVIEW_DOCUMENT_MODAL",
	HIDE_PREVIEW_DOCUMENT_MODAL = "HIDE_PREVIEW_DOCUMENT_MODAL",

	SHOW_PREVIEW_DOCUMENT_AS_PDF_MODAL = "SHOW_PREVIEW_DOCUMENT_AS_PDF_MODAL",
	HIDE_PREVIEW_DOCUMENT_AS_PDF_MODAL = "HIDE_PREVIEW_DOCUMENT_AS_PDF_MODAL",

	SET_AI_COVER_IMAGE_URL = "SET_AI_COVER_IMAGE_URL"
}

export type ShowDocumentsLoaderAction =
	Action<DocumentsActionTypes.SHOW_DOCUMENTS_LOADER>;
export type HideDocumentsLoaderAction =
	Action<DocumentsActionTypes.HIDE_DOCUMENTS_LOADER>;
export type DocumentsRequestedAction =
	Action<DocumentsActionTypes.DOCUMENTS_REQUESTED>;
export interface DocumentsSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENTS_SUCCESSFUL> {
	readonly documentList: Document[];
}
export type DocumentsFailedAction =
	Action<DocumentsActionTypes.DOCUMENTS_FAILED>;
export interface DocumentDetailsUpdatedAction
	extends Action<DocumentsActionTypes.DOCUMENT_DETAILS_UPDATED> {
	readonly currentActiveDocument: Document;
}
export type DocumentsResetAction = Action<DocumentsActionTypes.DOCUMENTS_RESET>;
export type DocumentDetailsRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_DETAILS_REQUESTED>;
export interface DocumentDetailsSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_DETAILS_SUCCESSFUL> {
	readonly currentActiveDocument: Document;
}
export type DocumentDetailsFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_DETAILS_FAILED>;
export type UpdateDocumentPaymentRequestedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_REQUESTED>;
export type UpdateDocumentPaymentSuccessfulAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_SUCCESSFUL>;
export type UpdateDocumentPaymentFailedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_FAILED>;
export type DocumentPaymentStatusRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_REQUESTED>;
export interface DocumentPaymentStatusSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_SUCCESSFUL> {
	readonly documentData: Document;
}
export type DocumentPaymentStatusFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_FAILED>;
export type StartDocumentPaymentRequestedAction =
	Action<DocumentsActionTypes.START_DOCUMENT_PAYMENT_REQUESTED>;
export interface StartDocumentPaymentSuccessfulAction
	extends Action<DocumentsActionTypes.START_DOCUMENT_PAYMENT_SUCCESSFUL> {
	readonly currentPaymentInitiated: Document;
}
export type StartDocumentPaymentFailedAction =
	Action<DocumentsActionTypes.START_DOCUMENT_PAYMENT_FAILED>;
export type UpdateClientDocumentPaymentRequestedAction =
	Action<DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_REQUESTED>;
export type UpdateClientDocumentPaymentSuccessfulAction =
	Action<DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_SUCCESSFUL>;
export type UpdateClientDocumentPaymentFailedAction =
	Action<DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_FAILED>;
export type DocumentPaymentRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_PAYMENT_REQUESTED>;
export interface DocumentPaymentSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_PAYMENT_SUCCESSFUL> {
	readonly documentPaymentStatus: Document;
}
export type DocumentPaymentFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_PAYMENT_FAILED>;
export type DocumentDetailsResetAction =
	Action<DocumentsActionTypes.DOCUMENT_DETAILS_RESET>;
export type DeleteDocumentRequestedAction =
	Action<DocumentsActionTypes.DELETE_DOCUMENT_REQUESTED>;
export interface DeleteDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.DELETE_DOCUMENT_SUCCESSFUL> {
	readonly deleteDocument: Document;
}
export type DeleteDocumentFailedAction =
	Action<DocumentsActionTypes.DELETE_DOCUMENT_FAILED>;
export type AddDocumentRequestedAction =
	Action<DocumentsActionTypes.ADD_DOCUMENT_REQUESTED>;
export interface AddDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.ADD_DOCUMENT_SUCCESSFUL> {
	readonly addDocument: Document;
}
export type AddDocumentFailedAction =
	Action<DocumentsActionTypes.ADD_DOCUMENT_FAILED>;
export type CloneDocumentRequestedAction =
	Action<DocumentsActionTypes.CLONE_DOCUMENT_REQUESTED>;
export interface CloneDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.CLONE_DOCUMENT_SUCCESSFUL> {
	readonly cloneDocument: Document;
}

export type CloneDocumentFailedAction =
	Action<DocumentsActionTypes.CLONE_DOCUMENT_FAILED>;
export type EditDocumentRequestedAction =
	Action<DocumentsActionTypes.EDIT_DOCUMENT_REQUESTED>;
export interface EditDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.EDIT_DOCUMENT_SUCCESSFUL> {
	readonly editDocument: Document;
}
export type EditDocumentFailedAction =
	Action<DocumentsActionTypes.EDIT_DOCUMENT_FAILED>;
export type DownloadDocumentRequestedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_REQUESTED>;
export type DownloadDocumentSuccessfulAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_SUCCESSFUL>;
export type DownloadDocumentFailedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_FAILED>;
export interface UpdateDocumentCountAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_COUNT> {
	readonly documentCount: DocumentCount;
}
export type ResetDocumentCountAction =
	Action<DocumentsActionTypes.RESET_DOCUMENT_COUNT>;
export type MailRecipientsRequestedAction =
	Action<DocumentsActionTypes.MAIL_RECIPIENTS_REQUESTED>;
export interface MailRecipientsSuccessfulAction
	extends Action<DocumentsActionTypes.MAIL_RECIPIENTS_SUCCESSFUL> {
	readonly mailRecipientList: MailRecipient[];
}
export type MailRecipientsFailedAction =
	Action<DocumentsActionTypes.MAIL_RECIPIENTS_FAILED>;
export type MailRecipientsResetAction =
	Action<DocumentsActionTypes.MAIL_RECIPIENTS_RESET>;
export type DownloadDocumentModalOpenedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_MODAL_OPENED>;
export type DownloadDocumentModalClosedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_MODAL_CLOSED>;
export type ExtendDocumentExpiryDateModalOpenedAction =
	Action<DocumentsActionTypes.EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_OPENED>;
export type ExtendDocumentExpiryDateModalClosedAction =
	Action<DocumentsActionTypes.EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_CLOSED>;
export type AddDocumentDrawerOpenedAction =
	Action<DocumentsActionTypes.ADD_DOCUMENT_DRAWER_OPENED>;
export type AddDocumentDrawerClosedAction =
	Action<DocumentsActionTypes.ADD_DOCUMENT_DRAWER_CLOSED>;
export type EditOrCloneDocumentDrawerOpenedAction =
	Action<DocumentsActionTypes.EDIT_OR_CLONE_DOCUMENT_DRAWER_OPENED>;
export type EditOrCloneDocumentDrawerClosedAction =
	Action<DocumentsActionTypes.EDIT_OR_CLONE_DOCUMENT_DRAWER_CLOSED>;
export type SendDocumentDrawerOpenedAction =
	Action<DocumentsActionTypes.SEND_DOCUMENT_DRAWER_OPENED>;
export type SendDocumentDrawerClosedAction =
	Action<DocumentsActionTypes.SEND_DOCUMENT_DRAWER_CLOSED>;

export type QuickbooksSyncDrawerOpenedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_SYNC_DRAWER_OPENED>;
export type QuickbooksSyncDrawerClosedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_SYNC_DRAWER_CLOSED>;

export interface UpdateDocumentRevisionBlockListAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST> {
	readonly block_list: string[];
}
export type UpdateDocumentRevisionBlockListFailedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED>;

export interface SetDocumentSidePanelAction
	extends Action<DocumentsActionTypes.SET_DOCUMENT_SIDE_PANEL> {
	readonly documentSidePanel: DocumentSidePanelEnum;
}

export type UpdateCurrentDocumentRequestedAction =
	Action<DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_REQUESTED>;
export interface UpdateCurrentDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL> {
	readonly updateCurrentDocument: Document;
}

export type RenewCurrentDocumentRequestedAction =
	Action<DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_REQUESTED>;
export interface RenewCurrentDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_SUCCESSFUL> {
	readonly updateCurrentDocument: Document;
}
export type RenewCurrentDocumentFailedAction =
	Action<DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_FAILED>;

export type UpdateCurrentDocumentFailedAction =
	Action<DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_FAILED>;

export type CreateTemplateFromDocumentRequestedAction =
	Action<DocumentsActionTypes.CREATE_TEMPLATE_FROM_DOCUMENT_REQUESTED>;
export type CreateTemplateFromDocumentSuccessfulAction =
	Action<DocumentsActionTypes.CREATE_TEMPLATE_FROM_DOCUMENT_SUCCESSFUL>;
export type CreateTemplateFromDocumentFailedAction =
	Action<DocumentsActionTypes.CREATE_TEMPLATE_FROM_DOCUMENT_FAILED>;

export type CancelSignatureFromDocumentRequestedAction =
	Action<DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_REQUESTED>;
export interface CancelSignatureFromDocumentSuccessfulAction
	extends Action<DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_SUCCESSFUL> {
	readonly document: Document;
}
export type CancelSignatureFromDocumentFailedAction =
	Action<DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_FAILED>;

export type UpdateDocumentDefaultsRequestedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_REQUESTED>;
export interface UpdateDocumentDefaultsSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_SUCCESSFUL> {
	readonly documentRevision: DocumentRevision;
}
export interface UpdateDocumentDefaultsFailedAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_FAILED> {
	readonly documentRevision: DocumentRevision;
}
export type UpdateMergeTagRequestedAction =
	Action<DocumentsActionTypes.UPDATE_MERGE_TAG_REQUESTED>;
export type UpdateMergeTagFailedAction =
	Action<DocumentsActionTypes.UPDATE_MERGE_TAG_FAILED>;
export interface UpdateMergeTagSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_MERGE_TAG_SUCCESSFUL> {
	readonly customMergeTagVariables?: MergeTagVariable[];
}

export type FetchEmptyMergeTagsRequestedAction =
	Action<DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_REQUESTED>;

export interface FetchEmptyMergeTagsSuccessfulAction
	extends Action<DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_SUCCESSFUL> {
	readonly emptyMergeTags: EmptyMergeTagResponse;
}

export type FetchEmptyMergeTagsFailedAction =
	Action<DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_FAILED>;

export type ValidateAutotaskItemsRequestedAction =
	Action<DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_REQUESTED>;

export interface ValidateAutotaskItemsSuccessfulAction
	extends Action<DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_SUCCESSFUL> {
	readonly invalidProducts: AutotaskProductValidationView[];
}

export type ValidateAutotaskItemsFailedAction =
	Action<DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_FAILED>;

export type DownloadDocumentProductListRequestedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_REQUESTED>;
export type DownloadDocumentProductListSuccessfulAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_SUCCESSFUL>;
export type DownloadDocumentProductListFailedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_FAILED>;

export type UpdateMergeTagsRequestedAction =
	Action<DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_REQUESTED>;
export interface UpdateMergeTagsSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_SUCCESSFUL> {
	readonly updateMergeTagErrors: any;
}
export type UpdateMergeTagsFailedAction =
	Action<DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_FAILED>;

export type ShowSignFlowConfirmationModalAction =
	Action<DocumentsActionTypes.SHOW_SIGN_FLOW_CONFIRMATION_MODAL>;
export type HideSignFlowConfirmationModalAction =
	Action<DocumentsActionTypes.HIDE_SIGN_FLOW_CONFIRMATION_MODAL>;
export type ShowPushChangesToPSAModalAction =
	Action<DocumentsActionTypes.SHOW_PUSH_CHANGES_TO_PSA_MODAL>;
export type HidePushChangesToPSAModalAction =
	Action<DocumentsActionTypes.HIDE_PUSH_CHANGES_TO_PSA_MODAL>;
export type DocumentLinkCopiedUpdateStatusRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_REQUESTED>;
export interface DocumentLinkCopiedUpdateStatusSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_SUCCESSFUL> {
	readonly currentActiveDocument: Document;
}
export type DocumentLinkCopiedUpdateStatusFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_FAILED>;

export type DocumentBulkUpdateStatusRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_REQUESTED>;
export type DocumentBulkUpdateStatusSuccessfulAction =
	Action<DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_SUCCESSFUL>;
export type DocumentBulkUpdateStatusFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_FAILED>;
export type OpenDocumentSidePaneAction =
	Action<DocumentsActionTypes.OPEN_DOCUMENT_SIDE_PANEL>;
export type CloseDocumentSidePaneAction =
	Action<DocumentsActionTypes.CLOSE_DOCUMENT_SIDE_PANEL>;

export type FetchDocumentViewMetadataRequested =
	Action<DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_REQUESTED>;
export interface FetchDocumentViewMetadataSuccessful
	extends Action<DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_SUCCESSFUL> {
	readonly metadata: CustomViewsMetadata;
}
export type FetchDocumentViewMetadataFailed =
	Action<DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_FAILED>;

export type FetchAllDocumentViewRequested =
	Action<DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_REQUESTED>;
export interface FetchAllDocumentViewSuccessful
	extends Action<DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_SUCCESSFUL> {
	readonly viewList: CustomViewResponse;
}
export type FetchAllDocumentViewFailed =
	Action<DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_FAILED>;

export type FetchDocumentListRequested =
	Action<DocumentsActionTypes.FETCH_DOCUMENT_LIST_REQUESTED>;
export interface FetchDocumentListSuccessful
	extends Action<DocumentsActionTypes.FETCH_DOCUMENT_LIST_SUCCESSFUL> {
	readonly documentList: DocumentsResponse;
}
export type FetchDocumentListFailed =
	Action<DocumentsActionTypes.FETCH_DOCUMENT_LIST_FAILED>;

export interface UpdateCurrentActiveViewAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW> {
	readonly currentActiveView: CustomView;
	readonly isViewChanged: boolean;
}

export type CreateDocumentViewRequestedAction =
	Action<DocumentsActionTypes.CREATE_DOCUMENT_VIEW_REQUESTED>;
export interface CreateDocumentViewSuccessfulAction
	extends Action<DocumentsActionTypes.CREATE_DOCUMENT_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type CreateDocumentViewFailedAction =
	Action<DocumentsActionTypes.CREATE_DOCUMENT_VIEW_FAILED>;

export type UpdateDocumentViewRequestedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_REQUESTED>;
export interface UpdateDocumentViewSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_SUCCESSFUL> {
	readonly view: CustomView;
}
export type UpdateDocumentViewFailedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_FAILED>;

export type DeleteDocumentViewRequestedAction =
	Action<DocumentsActionTypes.DELETE_DOCUMENT_VIEW_REQUESTED>;
export interface DeleteDocumentViewSuccessfulAction
	extends Action<DocumentsActionTypes.DELETE_DOCUMENT_VIEW_SUCCESSFUL> {
	readonly deletedView: CustomView;
	readonly initialView: CustomView;
}
export type DeleteDocumentViewFailedAction =
	Action<DocumentsActionTypes.DELETE_DOCUMENT_VIEW_FAILED>;

export type BulkActionRecordsSelectedAction =
	Action<DocumentsActionTypes.BULK_ACTION_RECORDS_SELECTED>;
export type BulkActionRecordsResetAction =
	Action<DocumentsActionTypes.BULK_ACTION_RECORDS_RESET>;

export type BulkDeleteRecordsRequestedAction =
	Action<DocumentsActionTypes.BULK_DELETE_RECORDS_REQUESTED>;
export type BulkDeleteRecordsSuccessfulAction =
	Action<DocumentsActionTypes.BULK_DELETE_RECORDS_SUCCESSFUL>;
export type BulkDeleteRecordsFailedAction =
	Action<DocumentsActionTypes.BULK_DELETE_RECORDS_FAILED>;

export type BulkUpdateRecordsRequestedAction =
	Action<DocumentsActionTypes.BULK_UPDATE_RECORDS_REQUESTED>;
export type BulkUpdateRecordsSuccessfulAction =
	Action<DocumentsActionTypes.BULK_UPDATE_RECORDS_SUCCESSFUL>;
export type BulkUpdateRecordsFailedAction =
	Action<DocumentsActionTypes.BULK_UPDATE_RECORDS_FAILED>;
export type ResetCurrentActiveViewAction =
	Action<DocumentsActionTypes.RESET_DOCUMENTS_CURRENT_ACTIVE_VIEW>;

export type DocumentApprovalRequestRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_REQUESTED>;
export interface DocumentApprovalRequestSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_SUCCESSFUL> {
	readonly documentApproval: ApprovalDetails;
	readonly documentId: string;
}
export type DocumentApprovalRequestFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_FAILED>;
export type DocumentApprovalVerdictRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_REQUESTED>;
export interface DocumentApprovalVerdictSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_SUCCESSFUL> {
	readonly documentApprovalVerdict: ApprovalDetails;
	readonly documentId: string;
}
export type DocumentApprovalVerdictFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_FAILED>;
export type FetchDocumentApprovalStatusRequestedAction =
	Action<DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_REQUESTED>;
export interface FetchDocumentApprovalStatusSuccessfulAction
	extends Action<DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_SUCCESSFUL> {
	readonly documentApprovalApprovalDetails: ApprovalStatusResponse;
}
export type FetchDocumentApprovalStatusFailedAction =
	Action<DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_FAILED>;

export type SendDocumentPinRequestedAction =
	Action<DocumentsActionTypes.SEND_DOCUMENT_PIN_REQUESTED>;
export interface SendDocumentPinSuccessfulAction
	extends Action<DocumentsActionTypes.SEND_DOCUMENT_PIN_SUCCESSFUL> {
	readonly data: DocumentPinGenerationResponse;
}
export type SendDocumentPinFailedAction =
	Action<DocumentsActionTypes.SEND_DOCUMENT_PIN_FAILED>;

export type VerifyDocumentPinRequestedAction =
	Action<DocumentsActionTypes.VERIFY_DOCUMENT_PIN_REQUESTED>;
export interface VerifyDocumentPinSuccessfulAction
	extends Action<DocumentsActionTypes.VERIFY_DOCUMENT_PIN_SUCCESSFUL> {
	readonly data: VerifyDocumentPinResponse;
}
export type VerifyDocumentPinFailedAction =
	Action<DocumentsActionTypes.VERIFY_DOCUMENT_PIN_FAILED>;

export type MakePaymentRequestedAction =
	Action<DocumentsActionTypes.MAKE_PAYMENT_REQUESTED>;
export interface MakePaymentSuccessfulAction
	extends Action<DocumentsActionTypes.MAKE_PAYMENT_SUCCESSFUL> {
	document: Document;
}

export type MakePaymentFailedAction =
	Action<DocumentsActionTypes.MAKE_PAYMENT_FAILED>;

export type UpdateDocumentPoDetailsRequestedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_REQUESTED>;
export interface UpdateDocumentPoDetailsSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_SUCCESSFUL> {
	poNumber: string | null;
}

export type UpdateDocumentPoDetailsFailedAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_FAILED>;

export type BulkAssignSignatureBlocksRequestedAction =
	Action<DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_REQUESTED>;
export interface BulkAssignSignatureBlocksSuccessfulAction
	extends Action<DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_SUCCESSFUL> {
	readonly document: Document;
}
export type BulkAssignSignatureBlocksFailedAction =
	Action<DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_FAILED>;

export interface UpdatePreviewPaymentSummaryAction
	extends Action<DocumentsActionTypes.UPDATE_PREVIEW_PAYMENT_SUMMARY> {
	showPaymentSummary: boolean | null;
	showPaymentTerms: boolean | null;
}

export type CreateCheckoutSessionRequestedAction =
	Action<DocumentsActionTypes.STRIPE_CHECKOUT_SESSION_REQUESTED>;
export type CreateCheckoutSessionSuccessfulAction =
	Action<DocumentsActionTypes.STRIPE_CHECKOUT_SESSION_SUCCESSFUL>;
export type CreateCheckoutSessionFailedAction =
	Action<DocumentsActionTypes.STRIPE_CHECKOUT_SESSION_FAILED>;
export type QuickbooksSyncMetadataRequestedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_REQUESTED>;
export interface QuickbooksSyncMetadataSuccessfulAction
	extends Action<DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_SUCCESSFUL> {
	readonly metadata: QuickbooksDocumentSyncFormData;
}
export type QuickbooksSyncMetadataFailedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_FAILED>;

export type QuickbooksSyncFormdataRequestedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_REQUESTED>;
export type QuickbooksSyncFormdataSuccessfulAction =
	Action<DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_SUCCESSFUL>;
export type QuickbooksSyncFormdataFailedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_FAILED>;

export type QuickbooksCustomersRequestedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_REQUESTED>;
export interface QuickbooksCustomersSuccessfulAction
	extends Action<DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_SUCCESSFUL> {
	readonly customers: CommonNameValuePair[];
}
export type QuickbooksCustomersFailedAction =
	Action<DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_FAILED>;

export type UpdateCurrentDocPaymentSummaryRequestedAction =
	Action<DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_REQUESTED>;

export type UpdateOrderFormPublishStatusRequestedAction =
	Action<DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_REQUESTED>;

export interface UpdateOrderFormPublishStatusSuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_SUCCESSFUL> {
	readonly documentStatus:
		| DocumentStatus.Published
		| DocumentStatus.Unpublished;
}

export type UpdateOrderFormPublishStatusFailedAction =
	Action<DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_FAILED>;

export interface UpdateCurrentDocPaymentSummarySuccessfulAction
	extends Action<DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL> {
	readonly paymentSummary: PaymentSummary | null;
}

export type UpdateCurrentDocPaymentSummaryFailedAction =
	Action<DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_FAILED>;

export type ExpireCurrentCheckoutSessionRequestedAction =
	Action<DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_REQUESTED>;

export type ExpireCurrentCheckoutSessionSuccessfulAction =
	Action<DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_SUCCESSFUL>;

export type ExpireCurrentCheckoutSessionFailedAction =
	Action<DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_FAILED>;

export type ShowDocumentsUnloaderAction =
	Action<DocumentsActionTypes.SHOW_DOCUMENTS_UNLOADER>;
export type HideDocumentsUnloaderAction =
	Action<DocumentsActionTypes.HIDE_DOCUMENTS_UNLOADER>;

export type UpdateDocumentLinkStatusSuccessfulAction =
	Action<DocumentsActionTypes.UPDATE_DOCUMENT_LINK_STATUS_SUCCESSFULL>;

export type DownloadDocumentLogsRequestedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_REQUESTED>;

export type DownloadDocumentLogsSuccessfulAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_SUCCESSFUL>;

export type DownloadDocumentLogsFailedAction =
	Action<DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_FAILED>;

export type ShowPreviewDocumentModalAction =
	Action<DocumentsActionTypes.SHOW_PREVIEW_DOCUMENT_MODAL>;
export type HidePreviewDocumentModalAction =
	Action<DocumentsActionTypes.HIDE_PREVIEW_DOCUMENT_MODAL>;

export type ShowPreviewDocumentAsPdfModalAction =
	Action<DocumentsActionTypes.SHOW_PREVIEW_DOCUMENT_AS_PDF_MODAL>;
export type HidePreviewDocumentAsPdfModalAction =
	Action<DocumentsActionTypes.HIDE_PREVIEW_DOCUMENT_AS_PDF_MODAL>;

export interface SetAiCoverImageUrlAction
	extends Action<DocumentsActionTypes.SET_AI_COVER_IMAGE_URL> {
	payload: string | null;
}

export type DocumentsActions =
	| ShowDocumentsLoaderAction
	| HideDocumentsLoaderAction
	| DocumentsRequestedAction
	| DocumentsSuccessfulAction
	| DocumentsFailedAction
	| DocumentDetailsUpdatedAction
	| DocumentsResetAction
	| DocumentDetailsRequestedAction
	| DocumentDetailsSuccessfulAction
	| DocumentDetailsFailedAction
	| UpdateDocumentPaymentRequestedAction
	| UpdateDocumentPaymentSuccessfulAction
	| UpdateDocumentPaymentFailedAction
	| DocumentPaymentStatusRequestedAction
	| DocumentPaymentStatusSuccessfulAction
	| DocumentPaymentStatusFailedAction
	| StartDocumentPaymentRequestedAction
	| StartDocumentPaymentSuccessfulAction
	| StartDocumentPaymentFailedAction
	| UpdateClientDocumentPaymentRequestedAction
	| UpdateClientDocumentPaymentSuccessfulAction
	| UpdateClientDocumentPaymentFailedAction
	| DocumentPaymentRequestedAction
	| DocumentPaymentSuccessfulAction
	| DocumentPaymentFailedAction
	| DocumentDetailsResetAction
	| DeleteDocumentRequestedAction
	| DeleteDocumentSuccessfulAction
	| DeleteDocumentFailedAction
	| AddDocumentRequestedAction
	| AddDocumentSuccessfulAction
	| AddDocumentFailedAction
	| CloneDocumentRequestedAction
	| CloneDocumentSuccessfulAction
	| CloneDocumentFailedAction
	| EditDocumentRequestedAction
	| EditDocumentSuccessfulAction
	| EditDocumentFailedAction
	| DownloadDocumentRequestedAction
	| DownloadDocumentSuccessfulAction
	| DownloadDocumentFailedAction
	| UpdateDocumentCountAction
	| ResetDocumentCountAction
	| MailRecipientsRequestedAction
	| MailRecipientsSuccessfulAction
	| MailRecipientsFailedAction
	| MailRecipientsResetAction
	| DownloadDocumentModalOpenedAction
	| DownloadDocumentModalClosedAction
	| AddDocumentDrawerOpenedAction
	| AddDocumentDrawerClosedAction
	| EditOrCloneDocumentDrawerOpenedAction
	| EditOrCloneDocumentDrawerClosedAction
	| SendDocumentDrawerOpenedAction
	| SendDocumentDrawerClosedAction
	| QuickbooksSyncDrawerOpenedAction
	| QuickbooksSyncDrawerClosedAction
	| UpdateDocumentRevisionBlockListAction
	| UpdateDocumentRevisionBlockListFailedAction
	| SetDocumentSidePanelAction
	| UpdateCurrentDocumentRequestedAction
	| UpdateCurrentDocumentSuccessfulAction
	| UpdateCurrentDocumentFailedAction
	| CreateTemplateFromDocumentRequestedAction
	| CreateTemplateFromDocumentSuccessfulAction
	| ExtendDocumentExpiryDateModalOpenedAction
	| ExtendDocumentExpiryDateModalClosedAction
	| RenewCurrentDocumentRequestedAction
	| RenewCurrentDocumentSuccessfulAction
	| RenewCurrentDocumentFailedAction
	| ShowSignFlowConfirmationModalAction
	| HideSignFlowConfirmationModalAction
	| ShowPushChangesToPSAModalAction
	| HidePushChangesToPSAModalAction
	| UpdateOrderFormPublishStatusRequestedAction
	| UpdateOrderFormPublishStatusSuccessfulAction
	| UpdateOrderFormPublishStatusFailedAction
	// Drawers
	| CreateTemplateFromDocumentFailedAction
	| CancelSignatureFromDocumentRequestedAction
	| CancelSignatureFromDocumentSuccessfulAction
	| CancelSignatureFromDocumentFailedAction
	| UpdateDocumentDefaultsRequestedAction
	| UpdateDocumentDefaultsSuccessfulAction
	| UpdateDocumentDefaultsFailedAction
	| UpdateMergeTagRequestedAction
	| UpdateMergeTagSuccessfulAction
	| UpdateMergeTagFailedAction
	| FetchEmptyMergeTagsRequestedAction
	| FetchEmptyMergeTagsSuccessfulAction
	| FetchEmptyMergeTagsFailedAction
	| ValidateAutotaskItemsRequestedAction
	| ValidateAutotaskItemsSuccessfulAction
	| ValidateAutotaskItemsFailedAction
	| DownloadDocumentProductListRequestedAction
	| DownloadDocumentProductListSuccessfulAction
	| DownloadDocumentProductListFailedAction
	| UpdateMergeTagsRequestedAction
	| UpdateMergeTagsSuccessfulAction
	| UpdateMergeTagsFailedAction
	| DocumentLinkCopiedUpdateStatusRequestedAction
	| DocumentLinkCopiedUpdateStatusSuccessfulAction
	| DocumentLinkCopiedUpdateStatusFailedAction
	| DocumentBulkUpdateStatusRequestedAction
	| DocumentBulkUpdateStatusSuccessfulAction
	| DocumentBulkUpdateStatusFailedAction
	| OpenDocumentSidePaneAction
	| CloseDocumentSidePaneAction
	| FetchDocumentViewMetadataRequested
	| FetchDocumentViewMetadataSuccessful
	| FetchDocumentViewMetadataFailed
	| FetchAllDocumentViewRequested
	| FetchAllDocumentViewSuccessful
	| FetchAllDocumentViewFailed
	| FetchDocumentListRequested
	| FetchDocumentListSuccessful
	| FetchDocumentListFailed
	| UpdateCurrentActiveViewAction
	| CreateDocumentViewRequestedAction
	| CreateDocumentViewSuccessfulAction
	| CreateDocumentViewFailedAction
	| UpdateDocumentViewRequestedAction
	| UpdateDocumentViewSuccessfulAction
	| UpdateDocumentViewFailedAction
	| DeleteDocumentViewRequestedAction
	| DeleteDocumentViewSuccessfulAction
	| DeleteDocumentViewFailedAction
	| ResetCurrentActiveViewAction
	| BulkActionRecordsSelectedAction
	| BulkActionRecordsResetAction
	| BulkDeleteRecordsRequestedAction
	| BulkDeleteRecordsSuccessfulAction
	| BulkDeleteRecordsFailedAction
	| BulkUpdateRecordsRequestedAction
	| BulkUpdateRecordsSuccessfulAction
	| BulkUpdateRecordsFailedAction
	| DocumentApprovalRequestRequestedAction
	| DocumentApprovalRequestSuccessfulAction
	| DocumentApprovalRequestFailedAction
	| DocumentApprovalVerdictRequestedAction
	| DocumentApprovalVerdictSuccessfulAction
	| DocumentApprovalVerdictFailedAction
	| FetchDocumentApprovalStatusRequestedAction
	| FetchDocumentApprovalStatusSuccessfulAction
	| FetchDocumentApprovalStatusFailedAction
	| SendDocumentPinRequestedAction
	| SendDocumentPinSuccessfulAction
	| SendDocumentPinFailedAction
	| VerifyDocumentPinRequestedAction
	| VerifyDocumentPinSuccessfulAction
	| VerifyDocumentPinFailedAction
	| MakePaymentRequestedAction
	| MakePaymentSuccessfulAction
	| MakePaymentFailedAction
	| UpdateDocumentPoDetailsRequestedAction
	| UpdateDocumentPoDetailsSuccessfulAction
	| UpdateDocumentPoDetailsFailedAction
	| BulkAssignSignatureBlocksRequestedAction
	| BulkAssignSignatureBlocksSuccessfulAction
	| BulkAssignSignatureBlocksFailedAction
	| UpdatePreviewPaymentSummaryAction
	| CreateCheckoutSessionRequestedAction
	| CreateCheckoutSessionSuccessfulAction
	| CreateCheckoutSessionFailedAction
	| QuickbooksSyncMetadataRequestedAction
	| QuickbooksSyncMetadataSuccessfulAction
	| QuickbooksSyncMetadataFailedAction
	| QuickbooksSyncFormdataRequestedAction
	| QuickbooksSyncFormdataSuccessfulAction
	| QuickbooksSyncFormdataFailedAction
	| QuickbooksCustomersRequestedAction
	| QuickbooksCustomersSuccessfulAction
	| QuickbooksCustomersFailedAction
	| CreateCheckoutSessionFailedAction
	| UpdateCurrentDocPaymentSummaryRequestedAction
	| UpdateCurrentDocPaymentSummarySuccessfulAction
	| UpdateCurrentDocumentFailedAction
	| ExpireCurrentCheckoutSessionRequestedAction
	| ExpireCurrentCheckoutSessionSuccessfulAction
	| ExpireCurrentCheckoutSessionFailedAction
	| ShowDocumentsUnloaderAction
	| HideDocumentsUnloaderAction
	| UpdateDocumentLinkStatusSuccessfulAction
	| DownloadDocumentLogsRequestedAction
	| DownloadDocumentLogsSuccessfulAction
	| DownloadDocumentLogsFailedAction
	| ShowPreviewDocumentModalAction
	| HidePreviewDocumentModalAction
	| ShowPreviewDocumentAsPdfModalAction
	| HidePreviewDocumentAsPdfModalAction
	| SetAiCoverImageUrlAction;

export interface DocumentsDispatch {
	showDocumentsLoader: ActionCreator<
		ThunkAction<
			ShowDocumentsLoaderAction,
			GlobalState,
			null,
			ShowDocumentsLoaderAction
		>
	>;
	hideDocumentsLoader: ActionCreator<
		ThunkAction<
			HideDocumentsLoaderAction,
			GlobalState,
			null,
			HideDocumentsLoaderAction
		>
	>;
	showDocumentsUnloader: ActionCreator<
		ThunkAction<
			ShowDocumentsUnloaderAction,
			GlobalState,
			null,
			ShowDocumentsUnloaderAction
		>
	>;
	hideDocumentsUnloader: ActionCreator<
		ThunkAction<
			HideDocumentsUnloaderAction,
			GlobalState,
			null,
			HideDocumentsUnloaderAction
		>
	>;
	getDocuments: ActionCreator<
		ThunkAction<
			Promise<DocumentsSuccessfulAction>,
			GlobalState,
			DocumentsRequest,
			DocumentsSuccessfulAction
		>
	>;
	resetDocuments: ActionCreator<
		ThunkAction<
			DocumentsResetAction,
			GlobalState,
			null,
			DocumentsResetAction
		>
	>;
	getDocumentDetails: ActionCreator<
		ThunkAction<
			Promise<DocumentDetailsSuccessfulAction>,
			GlobalState,
			DocumentDetailsRequest,
			DocumentDetailsSuccessfulAction
		>
	>;
	updateDocumentPaymentSettings: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentPaymentSuccessfulAction>,
			GlobalState,
			DocumentPayment,
			UpdateDocumentPaymentSuccessfulAction
		>
	>;
	startDocumentPayment: ActionCreator<
		ThunkAction<
			Promise<StartDocumentPaymentSuccessfulAction>,
			GlobalState,
			null,
			StartDocumentPaymentSuccessfulAction
		>
	>;
	updateClientDocumentPayment: ActionCreator<
		ThunkAction<
			Promise<UpdateClientDocumentPaymentSuccessfulAction>,
			GlobalState,
			null,
			UpdateClientDocumentPaymentSuccessfulAction
		>
	>;
	documentPayment: ActionCreator<
		ThunkAction<
			Promise<DocumentPaymentSuccessfulAction>,
			GlobalState,
			null,
			DocumentPaymentSuccessfulAction
		>
	>;
	documentPaymentStatus: ActionCreator<
		ThunkAction<
			Promise<DocumentPaymentStatusSuccessfulAction>,
			GlobalState,
			null,
			DocumentPaymentStatusSuccessfulAction
		>
	>;
	getDocumentDetailsFromClient: ActionCreator<
		ThunkAction<
			Promise<DocumentDetailsSuccessfulAction>,
			GlobalState,
			DocumentDetailsRequest,
			DocumentDetailsSuccessfulAction
		>
	>;
	updateDocumentDetails: ActionCreator<
		ThunkAction<
			DocumentDetailsUpdatedAction,
			GlobalState,
			Document,
			DocumentDetailsUpdatedAction
		>
	>;
	resetDocumentDetails: ActionCreator<
		ThunkAction<
			DocumentDetailsResetAction,
			GlobalState,
			null,
			DocumentDetailsResetAction
		>
	>;
	deleteDocument: ActionCreator<
		ThunkAction<
			Promise<DeleteDocumentSuccessfulAction>,
			GlobalState,
			Document,
			DeleteDocumentSuccessfulAction
		>
	>;
	addDocument: ActionCreator<
		ThunkAction<
			Promise<AddDocumentSuccessfulAction>,
			GlobalState,
			AddDocumentRequest,
			AddDocumentSuccessfulAction
		>
	>;
	cloneDocument: ActionCreator<
		ThunkAction<
			Promise<CloneDocumentSuccessfulAction>,
			GlobalState,
			CloneDocumentRequest,
			CloneDocumentSuccessfulAction
		>
	>;
	editDocument: ActionCreator<
		ThunkAction<
			Promise<EditDocumentSuccessfulAction>,
			GlobalState,
			Document,
			EditDocumentSuccessfulAction
		>
	>;
	downloadDocument: ActionCreator<
		ThunkAction<
			Promise<DownloadDocumentSuccessfulAction>,
			GlobalState,
			Document,
			DownloadDocumentSuccessfulAction
		>
	>;
	downloadDocumentFromClient: ActionCreator<
		ThunkAction<
			Promise<DownloadDocumentSuccessfulAction>,
			GlobalState,
			Document,
			DownloadDocumentSuccessfulAction
		>
	>;
	updateDocumentCount: ActionCreator<
		ThunkAction<
			UpdateDocumentCountAction,
			GlobalState,
			UpdateDocumentCountRequest,
			UpdateDocumentCountAction
		>
	>;
	resetDocumentCount: ActionCreator<
		ThunkAction<
			ResetDocumentCountAction,
			GlobalState,
			null,
			ResetDocumentCountAction
		>
	>;
	getMailRecipients: ActionCreator<
		ThunkAction<
			Promise<MailRecipientsSuccessfulAction>,
			GlobalState,
			null,
			MailRecipientsSuccessfulAction
		>
	>;
	resetMailRecipients: ActionCreator<
		ThunkAction<
			MailRecipientsResetAction,
			GlobalState,
			null,
			MailRecipientsResetAction
		>
	>;
	downloadDocumentModalOpened: ActionCreator<
		ThunkAction<
			DownloadDocumentModalOpenedAction,
			GlobalState,
			null,
			DownloadDocumentModalOpenedAction
		>
	>;
	downloadDocumentModalClosed: ActionCreator<
		ThunkAction<
			DownloadDocumentModalClosedAction,
			GlobalState,
			null,
			DownloadDocumentModalClosedAction
		>
	>;
	extendDocumentExpiryDateModalOpened: ActionCreator<
		ThunkAction<
			ExtendDocumentExpiryDateModalOpenedAction,
			GlobalState,
			null,
			ExtendDocumentExpiryDateModalOpenedAction
		>
	>;
	extendDocumentExpiryDateModalClosed: ActionCreator<
		ThunkAction<
			ExtendDocumentExpiryDateModalClosedAction,
			GlobalState,
			null,
			ExtendDocumentExpiryDateModalClosedAction
		>
	>;
	addDocumentDrawerOpened: ActionCreator<
		ThunkAction<
			AddDocumentDrawerOpenedAction,
			GlobalState,
			null,
			AddDocumentDrawerOpenedAction
		>
	>;
	addDocumentDrawerClosed: ActionCreator<
		ThunkAction<
			AddDocumentDrawerClosedAction,
			GlobalState,
			null,
			AddDocumentDrawerClosedAction
		>
	>;
	editOrCloneDocumentDrawerOpened: ActionCreator<
		ThunkAction<
			EditOrCloneDocumentDrawerOpenedAction,
			GlobalState,
			null,
			EditOrCloneDocumentDrawerOpenedAction
		>
	>;
	editOrCloneDocumentDrawerClosed: ActionCreator<
		ThunkAction<
			EditOrCloneDocumentDrawerClosedAction,
			GlobalState,
			null,
			EditOrCloneDocumentDrawerClosedAction
		>
	>;
	sendDocumentDrawerOpened: ActionCreator<
		ThunkAction<
			SendDocumentDrawerOpenedAction,
			GlobalState,
			null,
			SendDocumentDrawerOpenedAction
		>
	>;
	sendDocumentDrawerClosed: ActionCreator<
		ThunkAction<
			SendDocumentDrawerClosedAction,
			GlobalState,
			null,
			SendDocumentDrawerClosedAction
		>
	>;
	quickbooksSyncDrawerOpened: ActionCreator<
		ThunkAction<
			QuickbooksSyncDrawerOpenedAction,
			GlobalState,
			null,
			QuickbooksSyncDrawerOpenedAction
		>
	>;
	quickbooksSyncDrawerClosed: ActionCreator<
		ThunkAction<
			QuickbooksSyncDrawerClosedAction,
			GlobalState,
			null,
			QuickbooksSyncDrawerClosedAction
		>
	>;
	renewCurrentActiveDocument: ActionCreator<
		ThunkAction<
			Promise<RenewCurrentDocumentSuccessfulAction>,
			GlobalState,
			{ newExpiryDetails: DocumentExpiry },
			RenewCurrentDocumentSuccessfulAction
		>
	>;
	addBlockToRevision: ActionCreator<
		ThunkAction<
			Promise<string>,
			GlobalState,
			UpdateBlockListSequenceRequest,
			UpdateDocumentRevisionBlockListAction
		>
	>;

	linkBlockToRevision: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentRevisionBlockListAction>,
			GlobalState,
			UpdateBlockListSequenceRequest,
			UpdateDocumentRevisionBlockListAction
		>
	>;
	linkBlockListToRevision: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentRevisionBlockListAction>,
			GlobalState,
			UpdateMultipleBlockListSequenceRequest,
			UpdateDocumentRevisionBlockListAction
		>
	>;
	deleteBlockFromRevision: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentRevisionBlockListAction>,
			GlobalState,
			{ blockIds: string[] },
			UpdateDocumentRevisionBlockListAction
		>
	>;
	repositionBlockInRevision: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentRevisionBlockListAction>,
			GlobalState,
			BlockRepositionRequest,
			UpdateDocumentRevisionBlockListAction
		>
	>;
	updateCurrentDocument: ActionCreator<
		ThunkAction<
			Promise<UpdateCurrentDocumentSuccessfulAction>,
			GlobalState,
			BlockRepositionRequest,
			UpdateCurrentDocumentSuccessfulAction
		>
	>;
	approveCurrentDocument: ActionCreator<
		ThunkAction<
			Promise<UpdateCurrentDocumentSuccessfulAction>,
			GlobalState,
			null,
			UpdateCurrentDocumentSuccessfulAction
		>
	>;
	removeSignatureDocumentFromClient: ActionCreator<
		ThunkAction<
			Promise<CancelSignatureFromDocumentSuccessfulAction>,
			GlobalState,
			{ documentId: string },
			CancelSignatureFromDocumentSuccessfulAction
		>
	>;
	setSidePanel: ActionCreator<
		ThunkAction<
			SetDocumentSidePanelAction,
			GlobalState,
			DocumentSidePanelEnum,
			SetDocumentSidePanelAction
		>
	>;
	assignSignatureBlockToRecipient: ActionCreator<
		ThunkAction<
			Promise<UpdateCurrentDocumentSuccessfulAction>,
			GlobalState,
			{ blockId: string; signerId?: string },
			UpdateCurrentDocumentSuccessfulAction
		>
	>;
	reorderSigners: ActionCreator<
		ThunkAction<
			Promise<UpdateCurrentDocumentSuccessfulAction>,
			GlobalState,
			{ signerIds: DocumentRecipient[] },
			UpdateCurrentDocumentSuccessfulAction
		>
	>;
	updateDocumentDefaults: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentDefaultsSuccessfulAction>,
			GlobalState,
			{ defaults: DocumentDefaults },
			UpdateDocumentDefaultsSuccessfulAction
		>
	>;
	updateMergeTags: ActionCreator<
		ThunkAction<
			Promise<UpdateMergeTagSuccessfulAction>,
			GlobalState,
			MergeTagVariable[],
			UpdateMergeTagSuccessfulAction
		>
	>;
	fetchEmptyMergeTags: ActionCreator<
		ThunkAction<
			Promise<FetchEmptyMergeTagsSuccessfulAction>,
			GlobalState,
			{ documentId: string },
			FetchEmptyMergeTagsSuccessfulAction
		>
	>;
	fetchAutotaskItemValidation: ActionCreator<
		ThunkAction<
			Promise<ValidateAutotaskItemsSuccessfulAction>,
			GlobalState,
			{ documentId: string },
			ValidateAutotaskItemsSuccessfulAction
		>
	>;
	downloadDocumentProductList: ActionCreator<
		ThunkAction<
			Promise<DownloadDocumentProductListSuccessfulAction>,
			GlobalState,
			DownloadDocumentProductListRequest,
			DownloadDocumentProductListSuccessfulAction
		>
	>;
	updateMergeTagsValue: ActionCreator<
		ThunkAction<
			Promise<UpdateMergeTagsSuccessfulAction>,
			GlobalState,
			MergeTagInput,
			UpdateMergeTagsSuccessfulAction
		>
	>;
	showSignFlowConfirmationModal: ActionCreator<
		ThunkAction<
			ShowSignFlowConfirmationModalAction,
			GlobalState,
			null,
			ShowSignFlowConfirmationModalAction
		>
	>;
	hideSignFlowConfirmationModal: ActionCreator<
		ThunkAction<
			HideSignFlowConfirmationModalAction,
			GlobalState,
			null,
			HideSignFlowConfirmationModalAction
		>
	>;
	showPushChangesToPSAModal: ActionCreator<
		ThunkAction<
			ShowPushChangesToPSAModalAction,
			GlobalState,
			null,
			ShowPushChangesToPSAModalAction
		>
	>;
	hidePushChangesToPSAModal: ActionCreator<
		ThunkAction<
			HidePushChangesToPSAModalAction,
			GlobalState,
			null,
			HidePushChangesToPSAModalAction
		>
	>;
	documentLinkCopied: ActionCreator<
		ThunkAction<
			Promise<DocumentLinkCopiedUpdateStatusSuccessfulAction>,
			GlobalState,
			EditDocumentRequest,
			DocumentLinkCopiedUpdateStatusSuccessfulAction
		>
	>;
	updateDocumentStatusManually: ActionCreator<
		ThunkAction<
			Promise<DocumentBulkUpdateStatusSuccessfulAction>,
			GlobalState,
			DocumentBulkUpdateStatusRequest,
			DocumentBulkUpdateStatusSuccessfulAction
		>
	>;
	openDocumentSidePanel: ActionCreator<
		ThunkAction<
			OpenDocumentSidePaneAction,
			GlobalState,
			null,
			OpenDocumentSidePaneAction
		>
	>;
	closeDocumentSidePanel: ActionCreator<
		ThunkAction<
			CloseDocumentSidePaneAction,
			GlobalState,
			null,
			CloseDocumentSidePaneAction
		>
	>;
	fetchDocumentViewMetadata: ActionCreator<
		ThunkAction<
			Promise<FetchDocumentViewMetadataSuccessful>,
			GlobalState,
			null,
			FetchDocumentViewMetadataSuccessful
		>
	>;
	fetchAllDocumentView: ActionCreator<
		ThunkAction<
			Promise<FetchAllDocumentViewSuccessful>,
			GlobalState,
			null,
			FetchAllDocumentViewSuccessful
		>
	>;
	fetchAllDocuments: ActionCreator<
		ThunkAction<
			Promise<FetchDocumentListSuccessful>,
			GlobalState,
			ListPagePostRequest,
			FetchDocumentListSuccessful
		>
	>;
	updateCurrentActiveView: ActionCreator<
		ThunkAction<
			UpdateCurrentActiveViewAction,
			GlobalState,
			{ selectCurrentActiveView: CustomView; discardingView?: boolean },
			UpdateCurrentActiveViewAction
		>
	>;
	createDocumentView: ActionCreator<
		ThunkAction<
			Promise<CreateDocumentViewSuccessfulAction>,
			GlobalState,
			CustomView,
			CreateDocumentViewSuccessfulAction
		>
	>;
	updateDocumentView: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentViewSuccessfulAction>,
			GlobalState,
			CustomView,
			UpdateDocumentViewSuccessfulAction
		>
	>;
	deleteDocumentView: ActionCreator<
		ThunkAction<
			Promise<DeleteDocumentViewSuccessfulAction>,
			GlobalState,
			{ deleteView: CustomView; initialView: CustomView },
			DeleteDocumentViewSuccessfulAction
		>
	>;
	resetViews: ActionCreator<
		ThunkAction<
			ResetCurrentActiveViewAction,
			GlobalState,
			null,
			ResetCurrentActiveViewAction
		>
	>;
	bulkActionsRecordsSelected: ActionCreator<
		ThunkAction<
			BulkActionRecordsSelectedAction,
			GlobalState,
			null,
			BulkActionRecordsSelectedAction
		>
	>;
	bulkActionsRecordsReset: ActionCreator<
		ThunkAction<
			BulkActionRecordsResetAction,
			GlobalState,
			null,
			BulkActionRecordsResetAction
		>
	>;
	bulkDeleteRecords: ActionCreator<
		ThunkAction<
			Promise<BulkDeleteRecordsSuccessfulAction>,
			GlobalState,
			BulkDeleteRecordsRequest,
			BulkDeleteRecordsSuccessfulAction
		>
	>;
	bulkUpdateRecords: ActionCreator<
		ThunkAction<
			Promise<BulkUpdateRecordsSuccessfulAction>,
			GlobalState,
			BulkUpdateRecordsRequest,
			BulkUpdateRecordsSuccessfulAction
		>
	>;
	sendApprovalRequest: ActionCreator<
		ThunkAction<
			Promise<DocumentApprovalRequestSuccessfulAction>,
			GlobalState,
			DocumentApprovalSendRequest,
			DocumentApprovalRequestSuccessfulAction
		>
	>;
	sendApprovalVerdict: ActionCreator<
		ThunkAction<
			Promise<DocumentApprovalVerdictSuccessfulAction>,
			GlobalState,
			DocumentApprovalVerdictRequest,
			DocumentApprovalVerdictSuccessfulAction
		>
	>;
	fetchDocumentApprovalStatus: ActionCreator<
		ThunkAction<
			Promise<FetchDocumentApprovalStatusSuccessfulAction>,
			GlobalState,
			string,
			FetchDocumentApprovalStatusSuccessfulAction
		>
	>;
	sendDocumentPin: ActionCreator<
		ThunkAction<
			Promise<SendDocumentPinSuccessfulAction>,
			GlobalState,
			DocumentPinGenerationRequest,
			SendDocumentPinSuccessfulAction
		>
	>;
	verifyDocumentPin: ActionCreator<
		ThunkAction<
			Promise<VerifyDocumentPinSuccessfulAction>,
			GlobalState,
			DocumentPinVerificationRequest,
			VerifyDocumentPinSuccessfulAction
		>
	>;
	makePayment: ActionCreator<
		ThunkAction<
			Promise<MakePaymentSuccessfulAction>,
			GlobalState,
			MakePaymentPayload,
			MakePaymentSuccessfulAction
		>
	>;
	updateDocumentPoDetails: ActionCreator<
		ThunkAction<
			Promise<boolean>,
			GlobalState,
			UpdatePoDetailsPayload,
			UpdateDocumentPoDetailsSuccessfulAction
		>
	>;
	bulkAssignSignatureBlocks: ActionCreator<
		ThunkAction<
			Promise<BulkAssignSignatureBlocksSuccessfulAction>,
			GlobalState,
			{
				bulkAssignSignatureBlocksRequest: BulkAssignSignatureBlocksRequest;
				documentId: string;
			},
			BulkAssignSignatureBlocksSuccessfulAction
		>
	>;
	updatePreviewPaymentSummaryDetails: ActionCreator<
		ThunkAction<
			UpdatePreviewPaymentSummaryAction,
			GlobalState,
			{
				showPaymentSummary: boolean | null;
				showPaymentTerms: boolean | null;
			},
			UpdatePreviewPaymentSummaryAction
		>
	>;
	createCheckoutSession: ActionCreator<
		ThunkAction<
			Promise<string>,
			GlobalState,
			{
				documentId: string;
				gateway: Gateway;
				paymentMethod: PaymentMethod;
			},
			CreateCheckoutSessionSuccessfulAction
		>
	>;

	quickbooksSyncMetadata: ActionCreator<
		ThunkAction<
			Promise<QuickbooksSyncMetadataSuccessfulAction>,
			GlobalState,
			string,
			QuickbooksSyncMetadataSuccessfulAction
		>
	>;
	quickbooksSyncFormdata: ActionCreator<
		ThunkAction<
			Promise<QuickbooksSyncFormdataSuccessfulAction>,
			GlobalState,
			QuickbooksSyncFormDataParams,
			QuickbooksSyncFormdataSuccessfulAction
		>
	>;

	getQuickbooksCustomers: ActionCreator<
		ThunkAction<
			Promise<QuickbooksCustomersSuccessfulAction>,
			GlobalState,
			string,
			QuickbooksCustomersSuccessfulAction
		>
	>;

	expireCurrentStripeCheckoutSession: ActionCreator<
		ThunkAction<
			Promise<ExpireCurrentCheckoutSessionSuccessfulAction>,
			GlobalState,
			null,
			ExpireCurrentCheckoutSessionSuccessfulAction
		>
	>;

	updateOrderFormPublishStatus: ActionCreator<
		ThunkAction<
			Promise<UpdateOrderFormPublishStatusSuccessfulAction>,
			GlobalState,
			UpdateOrderFormPublishStatusRequest,
			UpdateOrderFormPublishStatusSuccessfulAction
		>
	>;

	updateDocumentLinkStatus: ActionCreator<
		ThunkAction<
			Promise<UpdateDocumentLinkStatusSuccessfulAction>,
			GlobalState,
			UpdateDocumentLinkStatusRequest,
			UpdateDocumentLinkStatusSuccessfulAction
		>
	>;

	updateDocumentPaymentSummary: ActionCreator<
		ThunkAction<
			UpdateCurrentDocPaymentSummarySuccessfulAction,
			GlobalState,
			PaymentSummary | null,
			UpdateCurrentDocPaymentSummarySuccessfulAction
		>
	>;

	downloadDocumentLogs: ActionCreator<
		ThunkAction<
			Promise<DownloadDocumentLogsSuccessfulAction>,
			GlobalState,
			DownloadDocumentLogsRequest,
			DownloadDocumentLogsSuccessfulAction
		>
	>;

	showPreviewDocumentModal: ActionCreator<
		ThunkAction<
			ShowPreviewDocumentModalAction,
			GlobalState,
			null,
			ShowPreviewDocumentModalAction
		>
	>;

	hidePreviewDocumentModal: ActionCreator<
		ThunkAction<
			HidePreviewDocumentModalAction,
			GlobalState,
			null,
			HidePreviewDocumentModalAction
		>
	>;

	showPreviewDocumentAsPdfModal: ActionCreator<
		ThunkAction<
			ShowPreviewDocumentAsPdfModalAction,
			GlobalState,
			null,
			ShowPreviewDocumentAsPdfModalAction
		>
	>;

	hidePreviewDocumentAsPdfModal: ActionCreator<
		ThunkAction<
			HidePreviewDocumentAsPdfModalAction,
			GlobalState,
			null,
			HidePreviewDocumentAsPdfModalAction
		>
	>;

	updateBlockList: ActionCreator<
		ThunkAction<void, GlobalState, null, Action>
	>;

	setAiCoverImageUrl: ActionCreator<
		ThunkAction<
			SetAiCoverImageUrlAction,
			GlobalState,
			null,
			SetAiCoverImageUrlAction
		>
	>;
}

const processDocumentDetailsResponse =
	(
		documentDetailsResponse: Document,
		documentDetailsRequest?: DocumentDetailsRequest,
		skipBlocksGet?: boolean
	) =>
	async (dispatch: Dispatch) => {
		// currency was not present in localstorage in Client PDF View and getting set to US $ by default
		if (documentDetailsResponse?.company?.settings) {
			const { currency, locale } =
				documentDetailsResponse?.company?.settings;
			if (currency && currency.length > 0) {
				cache.save(ZomentumStorageKeys.Currency, currency);
			}
			if (locale && locale.length > 0) {
				cache.save(ZomentumStorageKeys.Locale, locale);
			}
		}

		const latestRevision = Document.getLatestRevision(
			documentDetailsResponse
		);

		const latestRevisionId =
			(latestRevision && latestRevision.revision_id) || null;
		try {
			if (!latestRevisionId) {
				throw new Error("No document revision found");
			}
			const getBlockMapperRequestedAction: GetBlockMapperRequestedAction =
				{
					type: BlocksActionTypes.GET_BLOCK_MAPPER_REQUESTED
				};
			proposalBuilderStore.dispatch(getBlockMapperRequestedAction);
			let blocksList = latestRevision?.blocks?.data ?? [];
			if (!skipBlocksGet) {
				const blocksResponse = await getBlockList(
					documentDetailsResponse.id,
					latestRevisionId,
					(blocksList.length || documentDetailsRequest?.blockLimit) ??
						0,
					documentDetailsRequest?.blockIdCursor ?? null
				);
				blocksList = blocksResponse?.data ?? [];
			}
			// converting blockList into blockMapper

			let blockMapper: BlockMapper = blocksList.reduce(
				(total: BlockMapper, block: Block) => ({
					...total,
					[block.id]: block
				}),
				{}
			);
			if (
				documentDetailsResponse.is_single_block &&
				latestRevision?.rich_text_block_id &&
				latestRevision?.rich_text_block
			) {
				blockMapper[latestRevision.rich_text_block_id] =
					latestRevision?.rich_text_block ?? null;
			}
			const proposalBuilderState = proposalBuilderStore.getState();
			if (!!documentDetailsRequest?.blockIdCursor) {
				blockMapper = {
					...proposalBuilderState.blocks.blockMapper,
					...blockMapper
				};
			}
			const mergeTags = [
				...(documentDetailsResponse.merge_tag_system_variables ?? []),
				...(documentDetailsResponse.merge_tag_custom_variables ?? [])
			];

			Object.keys(blockMapper).forEach(blockId => {
				if (
					blockMapper[blockId]?.type === BlockType.TEXT &&
					mergeTags
				) {
					blockMapper[blockId] = {
						...blockMapper[blockId],
						data: {
							...blockMapper[blockId].data,
							text: updateMergeTagsDisplayName(
								mergeTags,
								(blockMapper[blockId].data as TextBlockData)
									.text
							)
						}
					};
				}
			});

			const getBlockMapperSuccessfulAction: GetBlockMapperSuccessfulAction =
				{
					type: BlocksActionTypes.GET_BLOCK_MAPPER_SUCCESSFUL,
					blockMapper
				};
			proposalBuilderStore.dispatch(getBlockMapperSuccessfulAction);
			const documentDetailsSuccessfulAction: DocumentDetailsSuccessfulAction =
				{
					type: DocumentsActionTypes.DOCUMENT_DETAILS_SUCCESSFUL,
					currentActiveDocument: documentDetailsResponse
				};
			const currentPaymentData = documentDetailsResponse?.payment;
			const updatePreviewPaymentSummaryDetailsAction: UpdatePreviewPaymentSummaryAction =
				{
					type: DocumentsActionTypes.UPDATE_PREVIEW_PAYMENT_SUMMARY,
					showPaymentSummary:
						currentPaymentData?.show_payment_summary ?? null,
					showPaymentTerms:
						currentPaymentData?.show_payment_terms ?? null
				};
			dispatch(updatePreviewPaymentSummaryDetailsAction);
			return dispatch(documentDetailsSuccessfulAction);
		} catch (error) {
			const getBlockMapperFailedAction: GetBlockMapperFailedAction = {
				type: BlocksActionTypes.GET_BLOCK_MAPPER_FAILED
			};
			proposalBuilderStore.dispatch(getBlockMapperFailedAction);
			console.error(error);
			throw error;
		}
	};

export const DocumentsActionCreators: DocumentsDispatch = {
	showDocumentsLoader: () => {
		return (dispatch: Dispatch): ShowDocumentsLoaderAction => {
			const showDocumentLoaderAction: ShowDocumentsLoaderAction = {
				type: DocumentsActionTypes.SHOW_DOCUMENTS_LOADER
			};
			return dispatch(showDocumentLoaderAction);
		};
	},
	hideDocumentsLoader: () => {
		return (dispatch: Dispatch): HideDocumentsLoaderAction => {
			const hideDocumentLoaderAction: HideDocumentsLoaderAction = {
				type: DocumentsActionTypes.HIDE_DOCUMENTS_LOADER
			};
			return dispatch(hideDocumentLoaderAction);
		};
	},
	showDocumentsUnloader: () => {
		return (dispatch: Dispatch): ShowDocumentsUnloaderAction => {
			const ShowDocumentsUnloaderAction: ShowDocumentsUnloaderAction = {
				type: DocumentsActionTypes.SHOW_DOCUMENTS_UNLOADER
			};
			return dispatch(ShowDocumentsUnloaderAction);
		};
	},
	hideDocumentsUnloader: () => {
		return (dispatch: Dispatch): HideDocumentsUnloaderAction => {
			const HideDocumentsUnloaderAction: HideDocumentsUnloaderAction = {
				type: DocumentsActionTypes.HIDE_DOCUMENTS_UNLOADER
			};
			return dispatch(HideDocumentsUnloaderAction);
		};
	},
	getDocuments: (documentsRequest: DocumentsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentsSuccessfulAction> => {
			const documentsRequestedAction: DocumentsRequestedAction = {
				type: DocumentsActionTypes.DOCUMENTS_REQUESTED
			};
			dispatch(documentsRequestedAction);
			try {
				const documentsResponse = await getDocuments(documentsRequest);
				const updateDocumentCountAction: UpdateDocumentCountAction = {
					type: DocumentsActionTypes.UPDATE_DOCUMENT_COUNT,
					documentCount: documentsResponse.filtered_count_map
				};
				dispatch(updateDocumentCountAction);
				const documentsSuccessfulAction: DocumentsSuccessfulAction = {
					type: DocumentsActionTypes.DOCUMENTS_SUCCESSFUL,
					documentList: documentsResponse.data
				};
				return dispatch(documentsSuccessfulAction);
			} catch (error) {
				const documentsFailedAction: DocumentsFailedAction = {
					type: DocumentsActionTypes.DOCUMENTS_FAILED
				};
				dispatch(documentsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetDocuments: () => {
		return (dispatch: Dispatch): DocumentsResetAction => {
			const documentsResetAction: DocumentsResetAction = {
				type: DocumentsActionTypes.DOCUMENTS_RESET
			};
			return dispatch(documentsResetAction);
		};
	},
	getDocumentDetails: (documentDetailsRequest: DocumentDetailsRequest) => {
		return async (
			dispatch: Dispatch,
			_getState: () => GlobalState
		): Promise<DocumentDetailsSuccessfulAction> => {
			const documentDetailsRequestedAction: DocumentDetailsRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_DETAILS_REQUESTED
				};
			dispatch(documentDetailsRequestedAction);
			try {
				const documentDetailsResponse = await getDocumentDetails(
					documentDetailsRequest.documentId,
					documentDetailsRequest.appendQueryParamAuth
				);
				return await processDocumentDetailsResponse(
					documentDetailsResponse,
					documentDetailsRequest,
					true
				)(dispatch);
			} catch (error) {
				const documentDetailsFailedAction: DocumentDetailsFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_DETAILS_FAILED
					};
				dispatch(documentDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateDocumentPaymentSettings: (
		documentId: string,
		documentPaymentUpdateRequest: DocumentPayment
	) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateDocumentPaymentSuccessfulAction> => {
			const documentPaymentRequestedAction: UpdateDocumentPaymentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_REQUESTED
				};
			dispatch(documentPaymentRequestedAction);
			try {
				await updateDocumentPaymentSettings(
					documentId,
					documentPaymentUpdateRequest
				);
				const documentPaymentSuccessfulAction: UpdateDocumentPaymentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_SUCCESSFUL
					};
				return dispatch(documentPaymentSuccessfulAction);
			} catch (error) {
				const documentPaymentFailedAction: UpdateDocumentPaymentFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_PAYMENT_FAILED
					};
				dispatch(documentPaymentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	startDocumentPayment: (documentId: string, mode: string) => {
		return async (
			dispatch: Dispatch
		): Promise<StartDocumentPaymentSuccessfulAction> => {
			const startDocumentPaymentRequestedAction: StartDocumentPaymentRequestedAction =
				{
					type: DocumentsActionTypes.START_DOCUMENT_PAYMENT_REQUESTED
				};
			dispatch(startDocumentPaymentRequestedAction);

			try {
				const startPaymentResponse = await startConnectBoosterPayment(
					documentId,
					mode
				);
				const startDocumentPaymentSuccessfulAction: StartDocumentPaymentSuccessfulAction =
					{
						type: DocumentsActionTypes.START_DOCUMENT_PAYMENT_SUCCESSFUL,
						currentPaymentInitiated: startPaymentResponse
					};
				return dispatch(startDocumentPaymentSuccessfulAction);
			} catch (error) {
				const startDocumentPaymentFailedAction: StartDocumentPaymentFailedAction =
					{
						type: DocumentsActionTypes.START_DOCUMENT_PAYMENT_FAILED
					};
				dispatch(startDocumentPaymentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateClientDocumentPayment: (
		paymentData: ClientPaymentData,
		documentToPay?: Document
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateClientDocumentPaymentSuccessfulAction> => {
			// get data
			const document =
				documentToPay ?? getState().documents.currentActiveDocument;
			const documentId = document && document.id;

			if (!documentId) {
				throw new Error("There is no active document to approve");
			}
			const updateClientDocumentPaymentRequestedAction: UpdateClientDocumentPaymentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_REQUESTED
				};
			dispatch(updateClientDocumentPaymentRequestedAction);
			try {
				await updateClientPaymentDetails(documentId, paymentData);
				const updateClientDocumentPaymentSuccessfulAction: UpdateClientDocumentPaymentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_SUCCESSFUL
					};
				return dispatch(updateClientDocumentPaymentSuccessfulAction);
			} catch (error) {
				const updateClientDocumentPaymentFailedAction: UpdateClientDocumentPaymentFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_CLIENT_DOCUMENT_PAYMENT_FAILED
					};
				dispatch(updateClientDocumentPaymentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	documentPayment: (connect_booster_payment_url: string) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentPaymentSuccessfulAction> => {
			const documentPaymentRequestedAction: DocumentPaymentRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_PAYMENT_REQUESTED
				};
			dispatch(documentPaymentRequestedAction);
			try {
				const documentPaymentStatus = await cbPayment(
					connect_booster_payment_url
				);
				const documentPaymentSuccessfulAction: DocumentPaymentSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_PAYMENT_SUCCESSFUL,
						documentPaymentStatus: documentPaymentStatus
					};
				return dispatch(documentPaymentSuccessfulAction);
			} catch (error) {
				const documentPaymentFailedAction: DocumentPaymentFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_PAYMENT_FAILED
					};
				dispatch(documentPaymentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	documentPaymentStatus: (connect_booster_payment_data: string) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentPaymentStatusSuccessfulAction> => {
			const documentPaymentStatusRequestedAction: DocumentPaymentStatusRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_REQUESTED
				};
			dispatch(documentPaymentStatusRequestedAction);
			try {
				const response = await getDocumentPaymentStatusCB(
					connect_booster_payment_data
				);
				const documentPaymentStatusSuccessfulAction: DocumentPaymentStatusSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_SUCCESSFUL,
						documentData: response
					};
				return dispatch(documentPaymentStatusSuccessfulAction);
			} catch (error) {
				const documentPaymentStatusFailedAction: DocumentPaymentStatusFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_PAYMENT_STATUS_FAILED
					};
				dispatch(documentPaymentStatusFailedAction);

				return Promise.reject(error);
			}
		};
	},
	getDocumentDetailsFromClient: (
		documentDetailsRequest: DocumentDetailsRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<DocumentDetailsSuccessfulAction> => {
			const documentDetailsRequestedAction: DocumentDetailsRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_DETAILS_REQUESTED
				};
			dispatch(documentDetailsRequestedAction);
			try {
				const { currentActiveDocument } = getState().documents;

				const isGOF =
					currentActiveDocument?.id ===
						documentDetailsRequest.documentId &&
					currentActiveDocument?.document_type ===
						DocumentType.GENERIC_ORDER_FORM;

				// fetching document
				const documentDetailsResponse =
					await getDocumentDetailsFromClient(
						documentDetailsRequest.documentId,
						isGOF
					);

				// handling gof block changes
				const isClientUser =
					getQueryParamAuthDetails()?.queryParam?.includes(
						QueryParamConstants.CLIENT_USER_ID
					);
				if (
					documentDetailsResponse?.document_type ===
						DocumentType.GENERIC_ORDER_FORM &&
					isClientUser
				) {
					updateGOFDocumentData(documentDetailsResponse);
				}

				// currency was not present in localstorage in Client PDF View and getting set to US $ by default

				if (documentDetailsResponse?.company?.settings) {
					const { currency, locale } =
						documentDetailsResponse?.company?.settings;
					if (currency && currency.length > 0) {
						cache.save(ZomentumStorageKeys.Currency, currency);
					}
					if (locale && locale.length > 0) {
						cache.save(ZomentumStorageKeys.Locale, locale);
					}
				}
				// requesting for the blocks
				const getBlockMapperRequestedAction: GetBlockMapperRequestedAction =
					{
						type: BlocksActionTypes.GET_BLOCK_MAPPER_REQUESTED
					};
				proposalBuilderStore.dispatch(getBlockMapperRequestedAction);

				const latestRevision = Document.getLatestRevision(
					documentDetailsResponse
				);

				const blockMapper: BlockMapper =
					latestRevision?.blocks?.data?.reduce(
						(total: BlockMapper, block: Block) => ({
							...total,
							[block.id]: block
						}),
						{}
					) || {};

				if (
					documentDetailsResponse.is_single_block &&
					latestRevision?.rich_text_block_id &&
					latestRevision?.rich_text_block
				) {
					blockMapper[latestRevision.rich_text_block_id] =
						latestRevision?.rich_text_block ?? null;
				}

				// updating the blocks to the state
				const getBlockMapperSuccessfulAction: GetBlockMapperSuccessfulAction =
					{
						type: BlocksActionTypes.GET_BLOCK_MAPPER_SUCCESSFUL,
						blockMapper
					};
				proposalBuilderStore.dispatch(getBlockMapperSuccessfulAction);

				// updating the document details to the state
				const documentDetailsSuccessfulAction: DocumentDetailsSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_DETAILS_SUCCESSFUL,
						currentActiveDocument: documentDetailsResponse
					};
				const currentPaymentData = documentDetailsResponse?.payment;
				const updatePreviewPaymentSummaryDetailsAction: UpdatePreviewPaymentSummaryAction =
					{
						type: DocumentsActionTypes.UPDATE_PREVIEW_PAYMENT_SUMMARY,
						showPaymentSummary:
							currentPaymentData?.show_payment_summary ?? null,
						showPaymentTerms:
							currentPaymentData?.show_payment_terms ?? null
					};
				dispatch(updatePreviewPaymentSummaryDetailsAction);
				return dispatch(documentDetailsSuccessfulAction);
			} catch (error) {
				const documentDetailsFailedAction: DocumentDetailsFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_DETAILS_FAILED
					};
				dispatch(documentDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateDocumentDetails: (currentActiveDocument: Document) => {
		return (dispatch: Dispatch): DocumentDetailsUpdatedAction => {
			const documentDetailsUpdatedAction: DocumentDetailsUpdatedAction = {
				type: DocumentsActionTypes.DOCUMENT_DETAILS_UPDATED,
				currentActiveDocument
			};
			return dispatch(documentDetailsUpdatedAction);
		};
	},
	resetDocumentDetails: () => {
		return (dispatch: Dispatch): DocumentDetailsResetAction => {
			const documentDetailsResetAction: DocumentDetailsResetAction = {
				type: DocumentsActionTypes.DOCUMENT_DETAILS_RESET
			};
			return dispatch(documentDetailsResetAction);
		};
	},
	deleteDocument: (deleteDocumentRequest: Document) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteDocumentSuccessfulAction> => {
			const deleteDocumentRequestedAction: DeleteDocumentRequestedAction =
				{
					type: DocumentsActionTypes.DELETE_DOCUMENT_REQUESTED
				};
			dispatch(deleteDocumentRequestedAction);
			try {
				const deleteDocumentResponse = await deleteDocument(
					deleteDocumentRequest
				);
				if (deleteDocumentResponse.deleted) {
					const deleteDocumentSuccessfulAction: DeleteDocumentSuccessfulAction =
						{
							type: DocumentsActionTypes.DELETE_DOCUMENT_SUCCESSFUL,
							deleteDocument: deleteDocumentRequest
						};
					return dispatch(deleteDocumentSuccessfulAction);
				} else {
					const deleteDocumentFailedAction: DeleteDocumentFailedAction =
						{
							type: DocumentsActionTypes.DELETE_DOCUMENT_FAILED
						};
					dispatch(deleteDocumentFailedAction);
					return Promise.reject(DefaultErrorMessage);
				}
			} catch (error) {
				const deleteDocumentFailedAction: DeleteDocumentFailedAction = {
					type: DocumentsActionTypes.DELETE_DOCUMENT_FAILED
				};
				dispatch(deleteDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	addDocument: (addDocumentRequest: AddDocumentRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<AddDocumentSuccessfulAction> => {
			const addDocumentRequestedAction: AddDocumentRequestedAction = {
				type: DocumentsActionTypes.ADD_DOCUMENT_REQUESTED
			};
			dispatch(addDocumentRequestedAction);
			try {
				const addDocumentResponse = await addDocument(
					addDocumentRequest
				);
				const addDocumentSuccessfulAction: AddDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.ADD_DOCUMENT_SUCCESSFUL,
						addDocument: addDocumentResponse
					};
				return dispatch(addDocumentSuccessfulAction);
			} catch (error) {
				const addDocumentFailedAction: AddDocumentFailedAction = {
					type: DocumentsActionTypes.ADD_DOCUMENT_FAILED
				};
				dispatch(addDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	cloneDocument: (cloneDocumentRequest: CloneDocumentRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<CloneDocumentSuccessfulAction> => {
			const cloneDocumentRequestedAction: CloneDocumentRequestedAction = {
				type: DocumentsActionTypes.CLONE_DOCUMENT_REQUESTED
			};
			dispatch(cloneDocumentRequestedAction);
			try {
				const addDocumentResponse = await addDocument(
					cloneDocumentRequest
				);
				const cloneDocumentSuccessfulAction: CloneDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.CLONE_DOCUMENT_SUCCESSFUL,
						cloneDocument: addDocumentResponse
					};
				return dispatch(cloneDocumentSuccessfulAction);
			} catch (error) {
				console.error(error);
				const addDocumentFailedAction: CloneDocumentFailedAction = {
					type: DocumentsActionTypes.CLONE_DOCUMENT_FAILED
				};
				dispatch(addDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	editDocument: (editDocumentRequest: EditDocumentRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<EditDocumentSuccessfulAction> => {
			const editDocumentRequestedAction: EditDocumentRequestedAction = {
				type: DocumentsActionTypes.EDIT_DOCUMENT_REQUESTED
			};
			dispatch(editDocumentRequestedAction);
			try {
				const editDocumentResponse = await editDocument(
					editDocumentRequest
				);
				const editDocumentSuccessfulAction: EditDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.EDIT_DOCUMENT_SUCCESSFUL,
						editDocument: editDocumentResponse
					};
				return dispatch(editDocumentSuccessfulAction);
			} catch (error) {
				const editDocumentFailedAction: EditDocumentFailedAction = {
					type: DocumentsActionTypes.EDIT_DOCUMENT_FAILED
				};
				dispatch(editDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateCurrentDocument:
		(updateCurrentDocumentRequest: EditDocumentRequest) =>
		async (
			dispatch: Dispatch
		): Promise<UpdateCurrentDocumentSuccessfulAction> => {
			const updateCurrentDocumentRequestedAction: UpdateCurrentDocumentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_REQUESTED
				};
			dispatch(updateCurrentDocumentRequestedAction);
			try {
				const updateCurrentDocumentResponse = await editDocument(
					updateCurrentDocumentRequest
				);
				const updateCurrentDocumentSuccessfulAction: UpdateCurrentDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL,
						updateCurrentDocument: updateCurrentDocumentResponse
					};
				return dispatch(updateCurrentDocumentSuccessfulAction);
			} catch (error) {
				const updateCurrentDocumentFailedAction: UpdateCurrentDocumentFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_FAILED
					};
				dispatch(updateCurrentDocumentFailedAction);

				return Promise.reject(error);
			}
		},
	downloadDocument: (downloadDocumentRequest: Document) => {
		return async (
			dispatch: Dispatch
		): Promise<DownloadDocumentSuccessfulAction> => {
			const downloadDocumentRequestedAction: DownloadDocumentRequestedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_REQUESTED
				};
			dispatch(downloadDocumentRequestedAction);
			try {
				const downloadDocumentResponse = await downloadDocument(
					downloadDocumentRequest
				);
				const downloadDocumentSuccessfulAction: DownloadDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_SUCCESSFUL
					};

				const ext = extension(downloadDocumentResponse.type);
				const documentName =
					downloadDocumentRequest?.name || "document";
				DownloadFile(
					downloadDocumentResponse,
					[documentName, ext].join(".")
				);

				return dispatch(downloadDocumentSuccessfulAction);
			} catch (error) {
				const downloadDocumentFailedAction: DownloadDocumentFailedAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_FAILED
					};
				dispatch(downloadDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	downloadDocumentFromClient: (
		downloadDocumentFromClientRequest: Document
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DownloadDocumentSuccessfulAction> => {
			const downloadDocumentRequestedAction: DownloadDocumentRequestedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_REQUESTED
				};
			dispatch(downloadDocumentRequestedAction);
			try {
				const documentName =
					downloadDocumentFromClientRequest &&
					downloadDocumentFromClientRequest.name &&
					downloadDocumentFromClientRequest.name.length > 0
						? downloadDocumentFromClientRequest.name
						: "document";
				const downloadDocumentResponse =
					await downloadDocumentFromClient(
						downloadDocumentFromClientRequest
					);
				const downloadDocumentSuccessfulAction: DownloadDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_SUCCESSFUL
					};

				const ext = extension(downloadDocumentResponse.type);
				DownloadFile(
					downloadDocumentResponse,
					[documentName, ext].join(".")
				);

				return dispatch(downloadDocumentSuccessfulAction);
			} catch (error) {
				const downloadDocumentFailedAction: DownloadDocumentFailedAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_FAILED
					};
				dispatch(downloadDocumentFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateDocumentCount: (
		updateDocumentCountRequest: UpdateDocumentCountRequest
	) => {
		return (
			dispatch: Dispatch,
			getState: () => GlobalState
		): UpdateDocumentCountAction => {
			const globalState = getState();
			let documentCount = new DocumentCount();
			if (
				globalState &&
				globalState.documents &&
				globalState.documents.documentCount
			) {
				documentCount = { ...globalState.documents.documentCount };
			}
			if (
				updateDocumentCountRequest.documentAdded &&
				!updateDocumentCountRequest.documentEdited &&
				!updateDocumentCountRequest.documentDeleted &&
				updateDocumentCountRequest.newDocumentStatus
			) {
				const oldDocumentCount =
					documentCount[updateDocumentCountRequest.newDocumentStatus];
				const newDocumentCount = oldDocumentCount + 1;
				documentCount.all = documentCount.all + 1;
				documentCount[updateDocumentCountRequest.newDocumentStatus] =
					newDocumentCount;
			} else if (
				!updateDocumentCountRequest.documentAdded &&
				updateDocumentCountRequest.documentEdited &&
				!updateDocumentCountRequest.documentDeleted &&
				updateDocumentCountRequest.oldDocumentStatus &&
				updateDocumentCountRequest.newDocumentStatus
			) {
				const oldDocumentCount =
					documentCount[
						updateDocumentCountRequest.oldDocumentStatus
					] - 1;
				const newDocumentCount =
					documentCount[
						updateDocumentCountRequest.newDocumentStatus
					] + 1;
				documentCount[updateDocumentCountRequest.oldDocumentStatus] =
					oldDocumentCount;
				documentCount[updateDocumentCountRequest.newDocumentStatus] =
					newDocumentCount;
			} else if (
				!updateDocumentCountRequest.documentAdded &&
				!updateDocumentCountRequest.documentEdited &&
				updateDocumentCountRequest.documentDeleted &&
				updateDocumentCountRequest.oldDocumentStatus
			) {
				const oldDocumentCount =
					documentCount[
						updateDocumentCountRequest.oldDocumentStatus
					] - 1;
				documentCount.all = documentCount.all - 1;
				documentCount[updateDocumentCountRequest.oldDocumentStatus] =
					oldDocumentCount;
			}
			const updateDocumentCountAction: UpdateDocumentCountAction = {
				type: DocumentsActionTypes.UPDATE_DOCUMENT_COUNT,
				documentCount
			};
			return dispatch(updateDocumentCountAction);
		};
	},
	resetDocumentCount: () => {
		return (dispatch: Dispatch): ResetDocumentCountAction => {
			const resetDocumentCountAction: ResetDocumentCountAction = {
				type: DocumentsActionTypes.RESET_DOCUMENT_COUNT
			};
			return dispatch(resetDocumentCountAction);
		};
	},
	getMailRecipients: () => {
		return async (
			dispatch: Dispatch
		): Promise<MailRecipientsSuccessfulAction> => {
			const mailRecipientsRequestedAction: MailRecipientsRequestedAction =
				{
					type: DocumentsActionTypes.MAIL_RECIPIENTS_REQUESTED
				};

			dispatch(mailRecipientsRequestedAction);

			try {
				const mailRecipientsResponse = await getMailRecipients();
				const mailRecipientsSuccessfulAction: MailRecipientsSuccessfulAction =
					{
						type: DocumentsActionTypes.MAIL_RECIPIENTS_SUCCESSFUL,
						mailRecipientList: mailRecipientsResponse.data
					};
				return dispatch(mailRecipientsSuccessfulAction);
			} catch (error) {
				const mailRecipientsFailedAction: MailRecipientsFailedAction = {
					type: DocumentsActionTypes.MAIL_RECIPIENTS_FAILED
				};
				dispatch(mailRecipientsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetMailRecipients: () => {
		return (dispatch: Dispatch): MailRecipientsResetAction => {
			const mailRecipientsResetAction: MailRecipientsResetAction = {
				type: DocumentsActionTypes.MAIL_RECIPIENTS_RESET
			};
			return dispatch(mailRecipientsResetAction);
		};
	},
	downloadDocumentModalOpened: () => {
		return (dispatch: Dispatch): DownloadDocumentModalOpenedAction => {
			const downloadDocumentModalOpenedAction: DownloadDocumentModalOpenedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_MODAL_OPENED
				};
			return dispatch(downloadDocumentModalOpenedAction);
		};
	},
	downloadDocumentModalClosed: () => {
		return (dispatch: Dispatch): DownloadDocumentModalClosedAction => {
			const downloadDocumentModalClosedAction: DownloadDocumentModalClosedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_MODAL_CLOSED
				};
			return dispatch(downloadDocumentModalClosedAction);
		};
	},
	extendDocumentExpiryDateModalOpened: () => {
		return (
			dispatch: Dispatch
		): ExtendDocumentExpiryDateModalOpenedAction => {
			const extendDocumentExpiryDateModalOpenedAction: ExtendDocumentExpiryDateModalOpenedAction =
				{
					type: DocumentsActionTypes.EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_OPENED
				};
			return dispatch(extendDocumentExpiryDateModalOpenedAction);
		};
	},
	extendDocumentExpiryDateModalClosed: () => {
		return (
			dispatch: Dispatch
		): ExtendDocumentExpiryDateModalClosedAction => {
			const extendDocumentExpiryDateModalClosedAction: ExtendDocumentExpiryDateModalClosedAction =
				{
					type: DocumentsActionTypes.EXTEND_DOCUMENT_EXPIRY_DATE_MODAL_CLOSED
				};
			return dispatch(extendDocumentExpiryDateModalClosedAction);
		};
	},
	addDocumentDrawerOpened: () => {
		return (dispatch: Dispatch): AddDocumentDrawerOpenedAction => {
			const addDocumentDrawerOpenedAction: AddDocumentDrawerOpenedAction =
				{
					type: DocumentsActionTypes.ADD_DOCUMENT_DRAWER_OPENED
				};
			return dispatch(addDocumentDrawerOpenedAction);
		};
	},
	addDocumentDrawerClosed: () => {
		return (dispatch: Dispatch): AddDocumentDrawerClosedAction => {
			const addDocumentDrawerClosedAction: AddDocumentDrawerClosedAction =
				{
					type: DocumentsActionTypes.ADD_DOCUMENT_DRAWER_CLOSED
				};
			return dispatch(addDocumentDrawerClosedAction);
		};
	},
	editOrCloneDocumentDrawerOpened: () => {
		return (dispatch: Dispatch): EditOrCloneDocumentDrawerOpenedAction => {
			const editOrCloneDocumentDrawerOpenedAction: EditOrCloneDocumentDrawerOpenedAction =
				{
					type: DocumentsActionTypes.EDIT_OR_CLONE_DOCUMENT_DRAWER_OPENED
				};
			return dispatch(editOrCloneDocumentDrawerOpenedAction);
		};
	},
	editOrCloneDocumentDrawerClosed: () => {
		return (dispatch: Dispatch): EditOrCloneDocumentDrawerClosedAction => {
			const editOrCloneDocumentDrawerClosedAction: EditOrCloneDocumentDrawerClosedAction =
				{
					type: DocumentsActionTypes.EDIT_OR_CLONE_DOCUMENT_DRAWER_CLOSED
				};
			return dispatch(editOrCloneDocumentDrawerClosedAction);
		};
	},
	sendDocumentDrawerOpened: () => {
		return (dispatch: Dispatch): SendDocumentDrawerOpenedAction => {
			const sendDocumentDrawerOpenedAction: SendDocumentDrawerOpenedAction =
				{
					type: DocumentsActionTypes.SEND_DOCUMENT_DRAWER_OPENED
				};
			return dispatch(sendDocumentDrawerOpenedAction);
		};
	},
	sendDocumentDrawerClosed: () => {
		return (dispatch: Dispatch): SendDocumentDrawerClosedAction => {
			const sendDocumentDrawerClosedAction: SendDocumentDrawerClosedAction =
				{
					type: DocumentsActionTypes.SEND_DOCUMENT_DRAWER_CLOSED
				};
			return dispatch(sendDocumentDrawerClosedAction);
		};
	},
	addBlockToRevision: (
		updateDocumentRevisionRequest: UpdateBlockListSequenceRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<string> => {
			const blockPlaceholder =
				LOADING_BLOCK_PLACEHOLDER + "::" + Date.now();
			const {
				draggableId,
				index,
				isNewQuoteBlockDesign,
				isQuoteBlockCompact
			} = updateDocumentRevisionRequest;
			try {
				let currentDocument =
					getState().documents.currentActiveDocument;
				const companyLabels =
					getState().user.userCompany.settings
						.pricing_table_default_label;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}
				const latestRevision =
					Document.getLatestRevision(currentDocument);

				// showing loader in the document
				let latestBlockList = latestRevision?.block_list || [];
				latestBlockList.splice(index, 0, blockPlaceholder); // Mutating Document block list

				const updatingDocumentWithBlockLoader: UpdateDocumentRevisionBlockListAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
						block_list: latestBlockList
					};
				dispatch(updatingDocumentWithBlockLoader);

				// creating the block
				const createBlockRequestedAction: CreateBlockRequestedAction = {
					type: BlocksActionTypes.CREATE_BLOCK_REQUESTED
				};
				proposalBuilderStore.dispatch(createBlockRequestedAction);

				const blockType = draggableIdToBlockTypeMapper[draggableId];

				let blockDataRequest = createNewBlock(
					blockType,
					currentDocument.document_type,
					isNewQuoteBlockDesign,
					undefined,
					undefined,
					isQuoteBlockCompact
				); // Creates new block data

				if (blockType === BlockType.QUOTE) {
					blockDataRequest = {
						...blockDataRequest,
						data: {
							...blockDataRequest.data,
							label: companyLabels ? { ...companyLabels } : null
						}
					};
				}

				const blockDataResponse = await addBlock(blockDataRequest); // Sends block data to BE
				const { ...blockData } = blockDataResponse;
				// updating the revision with the new block id and data
				const createBlockSuccessfulAction: CreateBlockSuccessfulAction =
					{
						type: BlocksActionTypes.CREATE_BLOCK_SUCCESSFUL,
						blockData
					};
				proposalBuilderStore.dispatch(createBlockSuccessfulAction);

				const newBlockId = blockDataResponse.id; // Id generated by the BE
				currentDocument = getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}
				latestBlockList =
					Document.getLatestRevision(currentDocument)?.block_list ||
					[];
				const placeholderIndex =
					latestBlockList.indexOf(blockPlaceholder);
				latestBlockList.splice(placeholderIndex, 1, newBlockId);

				const updatingDocumentWithNewBlockId: UpdateDocumentRevisionBlockListAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
						block_list: latestBlockList
					};
				currentDocument.revisions = currentDocument.revisions || [];
				currentDocument.revisions[0].block_list = latestBlockList;
				await updateRevisionBlockList({
					blockList: latestBlockList,
					documentId: currentDocument.id
				});

				dispatch(updatingDocumentWithNewBlockId);
				return newBlockId;
			} catch (error) {
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	linkBlockToRevision: (
		updateDocumentRevisionRequest: UpdateBlockListSequenceRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateDocumentRevisionBlockListAction> => {
			const { draggableId, index } = updateDocumentRevisionRequest;
			try {
				const currentDocument =
					getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}
				const latestRevision =
					Document.getLatestRevision(currentDocument);

				// showing loader in the document
				const latestBlockList = latestRevision?.block_list || [];
				latestBlockList.splice(index, 0, draggableId);

				const updatingDocumentWithNewBlockId: UpdateDocumentRevisionBlockListAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
						block_list: [...latestBlockList]
					};

				currentDocument.revisions = currentDocument.revisions || [];
				currentDocument.revisions[0].block_list = latestBlockList;

				await updateRevisionBlockList({
					blockList: latestBlockList,
					documentId: currentDocument.id
				});

				return dispatch(updatingDocumentWithNewBlockId);
			} catch (error) {
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	linkBlockListToRevision: (
		UpdateMultipleBlockListSequenceRequest: UpdateMultipleBlockListSequenceRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateDocumentRevisionBlockListAction> => {
			const { blockList, index } = UpdateMultipleBlockListSequenceRequest;

			const blockIdList = blockList?.map(
				(block: BlockResponse) => block.id
			);
			try {
				const currentDocument =
					getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}
				const latestRevision =
					Document.getLatestRevision(currentDocument);

				// showing loader in the document
				const latestBlockList = latestRevision?.block_list || [];
				latestBlockList.splice(index, 0, ...blockIdList);

				const updatingDocumentWithNewBlockId: UpdateDocumentRevisionBlockListAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
						block_list: [...latestBlockList]
					};

				currentDocument.revisions = currentDocument.revisions || [];
				currentDocument.revisions[0].block_list = latestBlockList;

				await updateRevisionBlockList({
					blockList: latestBlockList,
					documentId: currentDocument.id
				});

				const blockMapper = blockList.reduce(
					(tempObj: BlockMapper, blockData: BlockResponse) => ({
						...tempObj,
						[blockData.id]: blockData
					}),
					{}
				);
				const updateBlockMapperSuccessfulAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
					blockMapper
				};
				proposalBuilderStore.dispatch(
					updateBlockMapperSuccessfulAction
				);

				return dispatch(updatingDocumentWithNewBlockId);
			} catch (error) {
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteBlockFromRevision: ({ blockIds }: { blockIds: string[] }) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateDocumentRevisionBlockListAction> => {
			try {
				// updating the document revision
				const currentDocument =
					getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active document");
				}
				let latestBlockListIds =
					Document.getLatestRevisionBlockList(currentDocument);
				if (!latestBlockListIds) {
					throw new Error(
						"This is an Invalid Document. It has no revision."
					);
				}
				latestBlockListIds = latestBlockListIds.filter(
					id => !blockIds.includes(id)
				);

				currentDocument.revisions = currentDocument.revisions || [];
				currentDocument.revisions[0].block_list = latestBlockListIds;

				// making http calls
				const updatedDocument = await updateRevisionBlockList({
					documentId: currentDocument.id,
					blockList: latestBlockListIds
				});

				// updating active document in proposal builder
				const updateCurrentActiveDocumentInProposalBuilder: UpdateCurrentActiveDocumentAction =
					{
						type: ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT,
						currentActiveDocument: updatedDocument
					};
				proposalBuilderStore.dispatch(
					updateCurrentActiveDocumentInProposalBuilder
				);

				// updating the state
				const updateDocumentRevisionBlockListAction: UpdateDocumentRevisionBlockListAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
						block_list: latestBlockListIds
					};
				return dispatch(updateDocumentRevisionBlockListAction);
			} catch (error) {
				console.error(error);
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	repositionBlockInRevision: (
		repositionRevisionRequest: BlockRepositionRequest
	) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateDocumentRevisionBlockListAction> => {
			const { sourceIndex, destinationIndex } = repositionRevisionRequest;
			const currentDocument = getState().documents.currentActiveDocument;
			if (!currentDocument) {
				throw new Error("There is no active Document");
			}
			const latestRevision = Document.getLatestRevision(currentDocument);
			// showing loader in the document
			const latestBlockList = latestRevision?.block_list || [];
			latestBlockList.splice(
				destinationIndex,
				0,
				latestBlockList.splice(sourceIndex, 1)[0]
			);
			const updatingDocumentWithNewBlockId: UpdateDocumentRevisionBlockListAction =
				{
					type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST,
					block_list: latestBlockList
				};

			currentDocument.revisions = currentDocument.revisions || [];
			currentDocument.revisions[0].block_list = [...latestBlockList];
			await updateRevisionBlockList({
				documentId: currentDocument.id,
				blockList: latestBlockList
			});
			return dispatch(updatingDocumentWithNewBlockId);
		};
	},
	approveCurrentDocument:
		() =>
		async (
			dispatch: ThunkDispatch<GlobalState, any, Action>,
			getState: () => GlobalState
		): Promise<UpdateCurrentDocumentSuccessfulAction> => {
			const updateCurrentDocumentRequestedAction: UpdateCurrentDocumentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_REQUESTED
				};
			dispatch(updateCurrentDocumentRequestedAction);

			// get data
			const document = getState().documents.currentActiveDocument;
			const documentId = document && document.id;

			if (!documentId) {
				throw new Error("There is no active document to approve");
			}

			try {
				// approves === what the user sees
				await Promise.all(
					Object.values(
						proposalBuilderStore.getState().blocks.blockMapper
					)
						.filter(block => block.type === BlockType.QUOTE)
						.map(async block =>
							proposalBuilderStore.dispatch(
								BlocksActionCreators.updateBlockFromClient(
									block
								)
							)
						)
				);

				const documentResponse = await approveDocument(documentId);
				const updateCurrentDocumentSuccessfulAction: UpdateCurrentDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL,
						updateCurrentDocument: documentResponse
					};
				return dispatch(updateCurrentDocumentSuccessfulAction);
			} catch (error) {
				const updateCurrentDocumentFailedAction: UpdateCurrentDocumentFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_FAILED
					};
				dispatch(updateCurrentDocumentFailedAction);

				return Promise.reject(error);
			}
		},
	removeSignatureDocumentFromClient:
		({ documentId }: { documentId: string }) =>
		async (
			dispatch: Dispatch
		): Promise<CancelSignatureFromDocumentSuccessfulAction> => {
			const updateCurrentDocumentRequestedAction: CancelSignatureFromDocumentRequestedAction =
				{
					type: DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_REQUESTED
				};
			dispatch(updateCurrentDocumentRequestedAction);

			if (!documentId) {
				throw new Error("There is no active document to approve");
			}

			try {
				const documentResponse = await cancelSignatureFromClient(
					documentId
				);
				const updateCurrentDocumentSuccessfulAction: CancelSignatureFromDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_SUCCESSFUL,
						document: documentResponse
					};
				return dispatch(updateCurrentDocumentSuccessfulAction);
			} catch (error) {
				const updateCurrentDocumentFailedAction: CancelSignatureFromDocumentFailedAction =
					{
						type: DocumentsActionTypes.CANCEL_SIGNATURE_FROM_DOCUMENT_FAILED
					};
				dispatch(updateCurrentDocumentFailedAction);

				return Promise.reject(error);
			}
		},
	setSidePanel: panelTab => {
		return (dispatch: Dispatch): SetDocumentSidePanelAction => {
			const setDocumentSidePanelAction: SetDocumentSidePanelAction = {
				type: DocumentsActionTypes.SET_DOCUMENT_SIDE_PANEL,
				documentSidePanel: panelTab
			};

			return dispatch(setDocumentSidePanelAction);
		};
	},
	assignSignatureBlockToRecipient:
		({ blockId, signerId }: { blockId: string; signerId?: string }) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateCurrentDocumentSuccessfulAction> => {
			const updateCurrentDocumentRequestedAction: UpdateCurrentDocumentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_REQUESTED
				};
			dispatch(updateCurrentDocumentRequestedAction);
			try {
				const currentDocument =
					getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}

				const resp = await assignSignatureBlockToRecipient({
					documentId: currentDocument.id,
					blockId: blockId,
					signerId: signerId
				});

				const updateActionSuccessfull: UpdateCurrentDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL,
						updateCurrentDocument: resp
					};

				return dispatch(updateActionSuccessfull);
			} catch (error) {
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		},
	reorderSigners:
		({ signerIds }: { signerIds: string[] }) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateCurrentDocumentSuccessfulAction> => {
			const updateCurrentDocumentRequestedAction: UpdateCurrentDocumentRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_REQUESTED
				};
			dispatch(updateCurrentDocumentRequestedAction);
			try {
				const currentDocument =
					getState().documents.currentActiveDocument;
				if (!currentDocument) {
					throw new Error("There is no active Document");
				}

				const resp = await reorderSigners({
					documentId: currentDocument.id,
					signerIds: signerIds
				});

				const updateActionSuccessfull: UpdateCurrentDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL,
						updateCurrentDocument: resp
					};

				return dispatch(updateActionSuccessfull);
			} catch (error) {
				const updateDocumentRevisionBlockListFailedAction: UpdateDocumentRevisionBlockListFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_REVISION_BLOCK_LIST_FAILED
					};
				dispatch(updateDocumentRevisionBlockListFailedAction);

				return Promise.reject(error);
			}
		},
	updateDocumentDefaults:
		({ defaults }: { defaults: DocumentDefaults }) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateDocumentDefaultsSuccessfulAction> => {
			const globalState = getState();
			const currDocument = globalState.documents.currentActiveDocument;

			if (!currDocument) {
				throw new Error("Document is not active");
			}

			const latestRevision = Document.getLatestRevision(currDocument);

			if (!latestRevision) {
				throw new Error(
					`There is no Revision in this document: ${currDocument.id}`
				);
			}
			const prevDocumentDefaults = latestRevision?.defaults;

			try {
				const updateDocumentDefaultsRequestedAction: UpdateDocumentDefaultsRequestedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_REQUESTED
					};
				dispatch(updateDocumentDefaultsRequestedAction);
				const newRevisionData = {
					...latestRevision,
					defaults: {
						...prevDocumentDefaults,
						...defaults
					}
				};
				editRevision(currDocument.id, newRevisionData);

				const updateDocumentDefaultsSuccessfulAction: UpdateDocumentDefaultsSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_SUCCESSFUL,
						documentRevision: newRevisionData
					};
				return dispatch(updateDocumentDefaultsSuccessfulAction);
			} catch (error) {
				console.error(error);
				const updateDocumentDefaultsFailedAction: UpdateDocumentDefaultsFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_DEFAULTS_FAILED,
						documentRevision: latestRevision
					};
				dispatch(updateDocumentDefaultsFailedAction);
				throw error;
			}
		},

	updateMergeTags: (mergeTagVariables: MergeTagVariable[]) => {
		return async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<UpdateMergeTagSuccessfulAction> => {
			const updateMergeTagRequestAction: UpdateMergeTagRequestedAction = {
				type: DocumentsActionTypes.UPDATE_MERGE_TAG_REQUESTED
			};
			dispatch(updateMergeTagRequestAction);
			try {
				const currentActiveDocument =
					getState().documents.currentActiveDocument;
				if (!currentActiveDocument) {
					throw new Error("There is no active document");
				} else {
					const newDocumentToUpdate: Document = {
						...currentActiveDocument,
						merge_tag_custom_variables: mergeTagVariables
					};
					const editDocumentRequest = new EditDocumentRequest(
						newDocumentToUpdate,
						[ChildEntityHydrationParams.ACTIVITIES_ALL]
					);
					const editDocumentResponse = await editDocument(
						editDocumentRequest
					);
					const updateMergeTagSuccessfulAction: UpdateMergeTagSuccessfulAction =
						{
							type: DocumentsActionTypes.UPDATE_MERGE_TAG_SUCCESSFUL,
							customMergeTagVariables:
								editDocumentResponse.merge_tag_custom_variables
						};
					return dispatch(updateMergeTagSuccessfulAction);
				}
			} catch (error) {
				const updateMergeTagFailedAction: UpdateMergeTagFailedAction = {
					type: DocumentsActionTypes.UPDATE_MERGE_TAG_FAILED
				};
				dispatch(updateMergeTagFailedAction);

				return Promise.reject(error);
			}
		};
	},
	renewCurrentActiveDocument:
		(newExpiryDetails: DocumentExpiry) =>
		async (
			dispatch: Dispatch,
			getState: () => GlobalState
		): Promise<RenewCurrentDocumentSuccessfulAction> => {
			const renewCurrentActiveDocumentRequestAction: RenewCurrentDocumentRequestedAction =
				{
					type: DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_REQUESTED
				};
			dispatch(renewCurrentActiveDocumentRequestAction);

			// get data
			const document = getState().documents.currentActiveDocument;
			const documentId = document && document.id;

			if (!documentId) {
				throw new Error("There is no active document to approve");
			}

			try {
				const documentResponse = await renewCurrentActiveDocument(
					documentId,
					newExpiryDetails
				);
				const renewCurrentDocumentSuccessfulAction: RenewCurrentDocumentSuccessfulAction =
					{
						type: DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_SUCCESSFUL,
						updateCurrentDocument: documentResponse
					};
				return dispatch(renewCurrentDocumentSuccessfulAction);
			} catch (error) {
				const renewCurrentDocumentFailedAction: RenewCurrentDocumentFailedAction =
					{
						type: DocumentsActionTypes.RENEW_CURRENT_DOCUMENT_FAILED
					};
				dispatch(renewCurrentDocumentFailedAction);

				return Promise.reject(error);
			}
		},
	fetchEmptyMergeTags: (documentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchEmptyMergeTagsSuccessfulAction> => {
			const fetchEmptyMergeTagsRequestedAction: FetchEmptyMergeTagsRequestedAction =
				{
					type: DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_REQUESTED
				};
			dispatch(fetchEmptyMergeTagsRequestedAction);
			try {
				const response = await getEmptyMergeTags(documentId);
				const fetchEmptyMergeTagsSuccessfulAction: FetchEmptyMergeTagsSuccessfulAction =
					{
						type: DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_SUCCESSFUL,
						emptyMergeTags: response
					};
				return dispatch(fetchEmptyMergeTagsSuccessfulAction);
			} catch (error) {
				const fetchEmptyMergeTagsFailedAction: FetchEmptyMergeTagsFailedAction =
					{
						type: DocumentsActionTypes.FETCH_EMPTY_MERGE_TAGS_FAILED
					};
				dispatch(fetchEmptyMergeTagsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchAutotaskItemValidation: (documentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<ValidateAutotaskItemsSuccessfulAction> => {
			const requestedAction: ValidateAutotaskItemsRequestedAction = {
				type: DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_REQUESTED
			};
			dispatch(requestedAction);
			try {
				const response = await validateAutotaskItems(documentId);
				const successfulAction: ValidateAutotaskItemsSuccessfulAction =
					{
						type: DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_SUCCESSFUL,
						invalidProducts: response
					};
				return dispatch(successfulAction);
			} catch (error) {
				const failedAction: ValidateAutotaskItemsFailedAction = {
					type: DocumentsActionTypes.VALIDATE_AUTOTASK_ITEMS_FAILED
				};
				dispatch(failedAction);
				return Promise.reject(error);
			}
		};
	},
	downloadDocumentProductList: (
		downloadDocumentProductListRequest: DownloadDocumentProductListRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DownloadDocumentProductListSuccessfulAction> => {
			const downloadDocumentProductListRequestedAction: DownloadDocumentProductListRequestedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_REQUESTED
				};
			dispatch(downloadDocumentProductListRequestedAction);
			try {
				const downloadDocumentProductListResponse =
					await downloadDocumentProductList(
						downloadDocumentProductListRequest
					);
				const downloadDocumentProductListSuccessfulAction: DownloadDocumentProductListSuccessfulAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_SUCCESSFUL
					};

				const ext = extension(downloadDocumentProductListResponse.type);
				DownloadFile(
					downloadDocumentProductListResponse,
					[
						downloadDocumentProductListRequest.downloadedFileName,
						ext
					].join(".")
				);

				return dispatch(downloadDocumentProductListSuccessfulAction);
			} catch (error) {
				const downloadDocumentProductListFailedAction: DownloadDocumentProductListFailedAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_PRODUCT_LIST_FAILED
					};
				dispatch(downloadDocumentProductListFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateMergeTagsValue: (mergeTagsData: MergeTagInput) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateMergeTagsSuccessfulAction> => {
			const updateMergeTagsRequestedAction: UpdateMergeTagsRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_REQUESTED
				};
			dispatch(updateMergeTagsRequestedAction);
			try {
				const response = await updateMergeTagsByValue(mergeTagsData);
				const updateMergeTagsSuccessfulAction: UpdateMergeTagsSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_SUCCESSFUL,
						updateMergeTagErrors: response
					};
				return dispatch(updateMergeTagsSuccessfulAction);
			} catch (error) {
				const updateMergeTagsFailedAction: UpdateMergeTagsFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_MERGE_TAGS_VALUE_FAILED
					};
				dispatch(updateMergeTagsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	showSignFlowConfirmationModal: () => {
		return (dispatch: Dispatch): ShowSignFlowConfirmationModalAction => {
			const showSignFlowConfirmationModal: ShowSignFlowConfirmationModalAction =
				{
					type: DocumentsActionTypes.SHOW_SIGN_FLOW_CONFIRMATION_MODAL
				};
			return dispatch(showSignFlowConfirmationModal);
		};
	},
	hideSignFlowConfirmationModal: () => {
		return (dispatch: Dispatch): HideSignFlowConfirmationModalAction => {
			const hideSignFlowConfirmationModal: HideSignFlowConfirmationModalAction =
				{
					type: DocumentsActionTypes.HIDE_SIGN_FLOW_CONFIRMATION_MODAL
				};
			return dispatch(hideSignFlowConfirmationModal);
		};
	},
	showPushChangesToPSAModal: () => {
		return (dispatch: Dispatch): ShowPushChangesToPSAModalAction => {
			const showPushChangesToPSAModal: ShowPushChangesToPSAModalAction = {
				type: DocumentsActionTypes.SHOW_PUSH_CHANGES_TO_PSA_MODAL
			};
			return dispatch(showPushChangesToPSAModal);
		};
	},
	hidePushChangesToPSAModal: () => {
		return (dispatch: Dispatch): HidePushChangesToPSAModalAction => {
			const hidePushChangesToModal: HidePushChangesToPSAModalAction = {
				type: DocumentsActionTypes.HIDE_PUSH_CHANGES_TO_PSA_MODAL
			};
			return dispatch(hidePushChangesToModal);
		};
	},
	documentLinkCopied: (updatedDocument: EditDocumentRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentLinkCopiedUpdateStatusSuccessfulAction> => {
			const documentLinkCopiedUpdateStatusRequestedAction: DocumentLinkCopiedUpdateStatusRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_REQUESTED
				};
			dispatch(documentLinkCopiedUpdateStatusRequestedAction);
			try {
				const response = await editDocument(updatedDocument);
				const documentLinkCopiedUpdateStatusSuccessfulAction: DocumentLinkCopiedUpdateStatusSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_SUCCESSFUL,
						currentActiveDocument: response
					};
				return dispatch(documentLinkCopiedUpdateStatusSuccessfulAction);
			} catch (error) {
				const documentLinkCopiedUpdateStatusFailedAction: DocumentLinkCopiedUpdateStatusFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_LINK_COPIED_STATUS_UPDATE_FAILED
					};
				dispatch(documentLinkCopiedUpdateStatusFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateDocumentStatusManually: (
		updatedDocumentStatus: DocumentBulkUpdateStatusRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentBulkUpdateStatusSuccessfulAction> => {
			const documentBulkUpdateStatusRequestedAction: DocumentBulkUpdateStatusRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_REQUESTED
				};
			dispatch(documentBulkUpdateStatusRequestedAction);
			try {
				await documentBulkUpdate(updatedDocumentStatus);
				const documentBulkUpdateStatusSuccessfulAction: DocumentBulkUpdateStatusSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_SUCCESSFUL
					};
				return dispatch(documentBulkUpdateStatusSuccessfulAction);
			} catch (error) {
				const documentBulkUpdateStatusFailedAction: DocumentBulkUpdateStatusFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_BULK_UPDATE_STATUS_FAILED
					};
				dispatch(documentBulkUpdateStatusFailedAction);

				return Promise.reject(error);
			}
		};
	},
	openDocumentSidePanel: () => {
		return (dispatch: Dispatch): OpenDocumentSidePaneAction => {
			const openDocumentSidePaneAction: OpenDocumentSidePaneAction = {
				type: DocumentsActionTypes.OPEN_DOCUMENT_SIDE_PANEL
			};
			return dispatch(openDocumentSidePaneAction);
		};
	},
	closeDocumentSidePanel: () => {
		return (dispatch: Dispatch): CloseDocumentSidePaneAction => {
			const closeDocumentSidePaneAction: CloseDocumentSidePaneAction = {
				type: DocumentsActionTypes.CLOSE_DOCUMENT_SIDE_PANEL
			};
			return dispatch(closeDocumentSidePaneAction);
		};
	},
	fetchDocumentViewMetadata: () => {
		return async (
			dispatch: Dispatch
		): Promise<FetchDocumentViewMetadataSuccessful> => {
			const fetchDocumentViewMetadataRequested: FetchDocumentViewMetadataRequested =
				{
					type: DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_REQUESTED
				};

			dispatch(fetchDocumentViewMetadataRequested);

			try {
				const response = await getDocumentViewMetadata();
				const fetchDocumentViewMetadataSuccessful: FetchDocumentViewMetadataSuccessful =
					{
						type: DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_SUCCESSFUL,
						metadata: response
					};
				return dispatch(fetchDocumentViewMetadataSuccessful);
			} catch (error) {
				console.error(error);

				const fetchDocumentViewMetadataFailed: FetchDocumentViewMetadataFailed =
					{
						type: DocumentsActionTypes.FETCH_DOCUMENT_VIEW_METADATA_FAILED
					};
				dispatch(fetchDocumentViewMetadataFailed);

				return Promise.reject(error);
			}
		};
	},
	fetchAllDocumentView: () => {
		return async (
			dispatch: Dispatch
		): Promise<FetchAllDocumentViewSuccessful> => {
			const fetchAllDocumentViewRequested: FetchAllDocumentViewRequested =
				{
					type: DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_REQUESTED
				};

			dispatch(fetchAllDocumentViewRequested);

			try {
				const response = await getAllDocumentViews();
				const fetchAllDocumentViewSuccessful: FetchAllDocumentViewSuccessful =
					{
						type: DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_SUCCESSFUL,
						viewList: response
					};
				return dispatch(fetchAllDocumentViewSuccessful);
			} catch (error) {
				console.error(error);

				const fetchAllDocumentViewFailed: FetchAllDocumentViewFailed = {
					type: DocumentsActionTypes.FETCH_ALL_DOCUMENT_VIEWS_FAILED
				};
				dispatch(fetchAllDocumentViewFailed);

				return Promise.reject(error);
			}
		};
	},
	fetchAllDocuments: (documentRequest: ListPagePostRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<FetchDocumentListSuccessful> => {
			const fetchDocumentListRequested: FetchDocumentListRequested = {
				type: DocumentsActionTypes.FETCH_DOCUMENT_LIST_REQUESTED
			};
			dispatch(fetchDocumentListRequested);
			try {
				const response = await getDocumentListPost(documentRequest);

				const fetchDocumentListSuccessful: FetchDocumentListSuccessful =
					{
						type: DocumentsActionTypes.FETCH_DOCUMENT_LIST_SUCCESSFUL,
						documentList: response
					};

				return dispatch(fetchDocumentListSuccessful);
			} catch (error) {
				const fetchDocumentListFailed: FetchDocumentListFailed = {
					type: DocumentsActionTypes.FETCH_DOCUMENT_LIST_FAILED
				};

				dispatch(fetchDocumentListFailed);

				return Promise.reject(error);
			}
		};
	},
	updateCurrentActiveView: (
		selectedCurrentActiveView: CustomView,
		discardingView?: boolean
	) => {
		return (
			dispatch: Dispatch,
			getState: () => GlobalState
		): UpdateCurrentActiveViewAction => {
			const currentActiveView = getState().documents.currentActiveView;
			const prevViewData = getState().documents.viewList?.data.find(
				view => view.id === selectedCurrentActiveView?.id
			);

			const isSameView =
				currentActiveView?.id === selectedCurrentActiveView?.id;

			if (isSameView) {
				// if its a custom view then it would have an id
				if (prevViewData?.id) {
					const hasFiltersChanged = areFiltersChanged(
						prevViewData.filter_criteria,
						selectedCurrentActiveView.filter_criteria
					);

					const hasColumnsChanged =
						JSON.stringify(selectedCurrentActiveView.columns) !==
						JSON.stringify(prevViewData.columns);

					const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
						{
							type: DocumentsActionTypes.UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW,
							currentActiveView: selectedCurrentActiveView,
							isViewChanged: discardingView
								? false
								: hasFiltersChanged || hasColumnsChanged
						};
					return dispatch(updateCurrentActiveViewAction);
				}

				// if its a system view then no id

				if (currentActiveView) {
					const hasFiltersChanged = areFiltersChanged(
						currentActiveView.filter_criteria,
						selectedCurrentActiveView.filter_criteria
					);

					const hasColumnsChanged =
						JSON.stringify(selectedCurrentActiveView.columns) !==
						JSON.stringify(currentActiveView?.columns);

					const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
						{
							type: DocumentsActionTypes.UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW,
							currentActiveView: selectedCurrentActiveView,
							isViewChanged: discardingView
								? false
								: hasFiltersChanged || hasColumnsChanged
						};
					return dispatch(updateCurrentActiveViewAction);
				}
			}

			const updateCurrentActiveViewAction: UpdateCurrentActiveViewAction =
				{
					type: DocumentsActionTypes.UPDATE_DOCUMENTS_CURRENT_ACTIVE_VIEW,
					currentActiveView: selectedCurrentActiveView,
					isViewChanged: discardingView ? true : false
				};
			return dispatch(updateCurrentActiveViewAction);
		};
	},
	createDocumentView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<CreateDocumentViewSuccessfulAction> => {
			const createDocumentViewRequestedAction: CreateDocumentViewRequestedAction =
				{
					type: DocumentsActionTypes.CREATE_DOCUMENT_VIEW_REQUESTED
				};

			dispatch(createDocumentViewRequestedAction);

			try {
				const response = await createDocumentView(view);
				const createDocumentViewSuccessfulAction: CreateDocumentViewSuccessfulAction =
					{
						type: DocumentsActionTypes.CREATE_DOCUMENT_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(createDocumentViewSuccessfulAction);
			} catch (error) {
				const createDocumentViewFailedAction: CreateDocumentViewFailedAction =
					{
						type: DocumentsActionTypes.CREATE_DOCUMENT_VIEW_FAILED
					};
				dispatch(createDocumentViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	updateDocumentView: (view: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateDocumentViewSuccessfulAction> => {
			const updateDocumentViewRequestedAction: UpdateDocumentViewRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_REQUESTED
				};

			dispatch(updateDocumentViewRequestedAction);

			try {
				const response = await updateDocumentView(view);
				const updateDocumentViewSuccessfulAction: UpdateDocumentViewSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_SUCCESSFUL,
						view: response
					};
				return dispatch(updateDocumentViewSuccessfulAction);
			} catch (error) {
				const updateDocumentViewFailedAction: UpdateDocumentViewFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_VIEW_FAILED
					};
				dispatch(updateDocumentViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	deleteDocumentView: (deleteView: CustomView, initialView: CustomView) => {
		return async (
			dispatch: Dispatch
		): Promise<DeleteDocumentViewSuccessfulAction> => {
			const deleteDocumentViewRequestedAction: DeleteDocumentViewRequestedAction =
				{
					type: DocumentsActionTypes.DELETE_DOCUMENT_VIEW_REQUESTED
				};

			dispatch(deleteDocumentViewRequestedAction);

			try {
				await deleteDocumentView(deleteView.id);
				const deleteDocumentViewSuccessfulAction: DeleteDocumentViewSuccessfulAction =
					{
						type: DocumentsActionTypes.DELETE_DOCUMENT_VIEW_SUCCESSFUL,
						deletedView: deleteView,
						initialView: initialView
					};
				return dispatch(deleteDocumentViewSuccessfulAction);
			} catch (error) {
				const deleteDocumentViewFailedAction: DeleteDocumentViewFailedAction =
					{
						type: DocumentsActionTypes.DELETE_DOCUMENT_VIEW_FAILED
					};
				dispatch(deleteDocumentViewFailedAction);

				return Promise.reject(error);
			}
		};
	},
	resetViews: () => {
		return (dispatch: Dispatch): ResetCurrentActiveViewAction => {
			const resetCurrentActiveViewAction: ResetCurrentActiveViewAction = {
				type: DocumentsActionTypes.RESET_DOCUMENTS_CURRENT_ACTIVE_VIEW
			};

			return dispatch(resetCurrentActiveViewAction);
		};
	},
	bulkActionsRecordsSelected: () => {
		return (dispatch: Dispatch): BulkActionRecordsSelectedAction => {
			const bulkActionRecordsSelectedAction: BulkActionRecordsSelectedAction =
				{
					type: DocumentsActionTypes.BULK_ACTION_RECORDS_SELECTED
				};

			return dispatch(bulkActionRecordsSelectedAction);
		};
	},
	bulkActionsRecordsReset: () => {
		return (dispatch: Dispatch): BulkActionRecordsResetAction => {
			const bulkActionRecordsResetAction: BulkActionRecordsResetAction = {
				type: DocumentsActionTypes.BULK_ACTION_RECORDS_RESET
			};

			return dispatch(bulkActionRecordsResetAction);
		};
	},
	bulkDeleteRecords: (deleteRecordsRequest: BulkDeleteRecordsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<BulkDeleteRecordsSuccessfulAction> => {
			const bulkDeleteRecordsRequestedAction: BulkDeleteRecordsRequestedAction =
				{
					type: DocumentsActionTypes.BULK_DELETE_RECORDS_REQUESTED
				};

			dispatch(bulkDeleteRecordsRequestedAction);

			try {
				await bulkDeleteDocumentRecords(deleteRecordsRequest);

				const bulkDeleteRecordsSuccessfulAction: BulkDeleteRecordsSuccessfulAction =
					{
						type: DocumentsActionTypes.BULK_DELETE_RECORDS_SUCCESSFUL
					};

				return dispatch(bulkDeleteRecordsSuccessfulAction);
			} catch (error) {
				const bulkDeleteRecordsFailedAction: BulkDeleteRecordsFailedAction =
					{
						type: DocumentsActionTypes.BULK_DELETE_RECORDS_FAILED
					};
				dispatch(bulkDeleteRecordsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	bulkUpdateRecords: (updateRecordsRequest: BulkUpdateRecordsRequest) => {
		return async (
			dispatch: Dispatch
		): Promise<BulkUpdateRecordsSuccessfulAction> => {
			const bulkUpdateRecordsRequestedAction: BulkUpdateRecordsRequestedAction =
				{
					type: DocumentsActionTypes.BULK_UPDATE_RECORDS_REQUESTED
				};

			dispatch(bulkUpdateRecordsRequestedAction);

			try {
				await bulkUpdateRecords(updateRecordsRequest);

				const bulkUpdateRecordsSuccessfulAction: BulkUpdateRecordsSuccessfulAction =
					{
						type: DocumentsActionTypes.BULK_UPDATE_RECORDS_SUCCESSFUL
					};

				return dispatch(bulkUpdateRecordsSuccessfulAction);
			} catch (error) {
				const bulkUpdateRecordsFailedAction: BulkUpdateRecordsFailedAction =
					{
						type: DocumentsActionTypes.BULK_UPDATE_RECORDS_FAILED
					};
				dispatch(bulkUpdateRecordsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	sendApprovalRequest: (
		documentApprovalSendRequest: DocumentApprovalSendRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentApprovalRequestSuccessfulAction> => {
			const documentApprovalRequestRequestedAction: DocumentApprovalRequestRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_REQUESTED
				};
			dispatch(documentApprovalRequestRequestedAction);

			try {
				const response = await sendDocumentApprovalRequest(
					documentApprovalSendRequest
				);

				const documentApprovalRequestSuccessfulAction: DocumentApprovalRequestSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_SUCCESSFUL,
						documentApproval: response,
						documentId: documentApprovalSendRequest.document_id
					};
				return dispatch(documentApprovalRequestSuccessfulAction);
			} catch (error) {
				const documentApprovalRequestFailedAction: DocumentApprovalRequestFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_APPROVAL_REQUEST_FAILED
					};
				dispatch(documentApprovalRequestFailedAction);

				return Promise.reject(error);
			}
		};
	},
	sendApprovalVerdict: (
		documentApprovalVerdictRequest: DocumentApprovalVerdictRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DocumentApprovalVerdictSuccessfulAction> => {
			const documentApprovalVerdictRequestedAction: DocumentApprovalVerdictRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_REQUESTED
				};
			dispatch(documentApprovalVerdictRequestedAction);

			try {
				const response = await sendDocumentApprovalVerdict(
					documentApprovalVerdictRequest
				);

				const documentApprovalVerdictSuccessfulAction: DocumentApprovalVerdictSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_SUCCESSFUL,
						documentApprovalVerdict: response,
						documentId: documentApprovalVerdictRequest.document_id
					};
				return dispatch(documentApprovalVerdictSuccessfulAction);
			} catch (error) {
				const documentApprovalVerdictFailedAction: DocumentApprovalVerdictFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_APPROVAL_VERDICT_FAILED
					};
				dispatch(documentApprovalVerdictFailedAction);

				return Promise.reject(error);
			}
		};
	},
	fetchDocumentApprovalStatus: (documentId: string, apiVersion = "v2") => {
		return async (
			dispatch: Dispatch
		): Promise<FetchDocumentApprovalStatusSuccessfulAction> => {
			const fetchDocumentApprovalStatusRequestedAction: FetchDocumentApprovalStatusRequestedAction =
				{
					type: DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_REQUESTED
				};

			dispatch(fetchDocumentApprovalStatusRequestedAction);

			try {
				const response = await fetchDocumentApprovalStatus(
					documentId,
					apiVersion
				);

				const fetchDocumentApprovalStatusSuccessfulAction: FetchDocumentApprovalStatusSuccessfulAction =
					{
						type: DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_SUCCESSFUL,
						documentApprovalApprovalDetails: response
					};

				return dispatch(fetchDocumentApprovalStatusSuccessfulAction);
			} catch (error) {
				const fetchDocumentApprovalStatusFailedAction: FetchDocumentApprovalStatusFailedAction =
					{
						type: DocumentsActionTypes.DOCUMENT_FETCH_APPROVAL_STATUS_FAILED
					};

				dispatch(fetchDocumentApprovalStatusFailedAction);

				return Promise.reject(error);
			}
		};
	},
	sendDocumentPin: (
		documentPinGenerationRequest: DocumentPinGenerationRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<SendDocumentPinSuccessfulAction> => {
			const sendDocumentPinRequestedAction: SendDocumentPinRequestedAction =
				{
					type: DocumentsActionTypes.SEND_DOCUMENT_PIN_REQUESTED
				};

			dispatch(sendDocumentPinRequestedAction);

			try {
				const response = await sendDocumentPin(
					documentPinGenerationRequest
				);

				const sendDocumentPinSuccessfulAction: SendDocumentPinSuccessfulAction =
					{
						type: DocumentsActionTypes.SEND_DOCUMENT_PIN_SUCCESSFUL,
						data: response
					};

				return dispatch(sendDocumentPinSuccessfulAction);
			} catch (error) {
				const sendDocumentPinFailed: SendDocumentPinFailedAction = {
					type: DocumentsActionTypes.SEND_DOCUMENT_PIN_FAILED
				};

				dispatch(sendDocumentPinFailed);
				return Promise.reject(error);
			}
		};
	},
	verifyDocumentPin: (
		documentPinVerificationRequest: DocumentPinVerificationRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<VerifyDocumentPinSuccessfulAction> => {
			const verifyDocumentPinRequestedAction: VerifyDocumentPinRequestedAction =
				{
					type: DocumentsActionTypes.VERIFY_DOCUMENT_PIN_REQUESTED
				};

			dispatch(verifyDocumentPinRequestedAction);

			try {
				const response = await verifyDocumentPin(
					documentPinVerificationRequest
				);

				const verifyDocumentPinSuccessfulAction: VerifyDocumentPinSuccessfulAction =
					{
						type: DocumentsActionTypes.VERIFY_DOCUMENT_PIN_SUCCESSFUL,
						data: response
					};

				return dispatch(verifyDocumentPinSuccessfulAction);
			} catch (error) {
				const VerifyDocumentPinFailed: VerifyDocumentPinFailedAction = {
					type: DocumentsActionTypes.VERIFY_DOCUMENT_PIN_FAILED
				};

				dispatch(VerifyDocumentPinFailed);
				return Promise.reject(error);
			}
		};
	},
	makePayment: (payload: MakePaymentPayload) => {
		return async (
			dispatch: Dispatch
		): Promise<MakePaymentSuccessfulAction> => {
			const makePaymentRequestedAction: MakePaymentRequestedAction = {
				type: DocumentsActionTypes.MAKE_PAYMENT_REQUESTED
			};
			dispatch(makePaymentRequestedAction);

			try {
				const connectBoosterPaymentRequest: ConnectBoosterPaymentRequest =
					{
						payment_method: payload.paymentMethod,
						payment_version: payload.paymentVersion,
						ach_account_type: payload.achAccountType,
						ach_entity_type: payload.achEntityType,
						transaction_token: payload.transactionToken,
						ach_sec_code: payload.achSecCode
					};
				const document: Document = await makeConnectBoosterPayment(
					payload.documentId,
					connectBoosterPaymentRequest,
					payload.optOut
				);
				if (document.payment?.payment_failed_reason) {
					throw new Error(document.payment?.payment_failed_reason);
				}
				const makePaymentSuccessfulAction: MakePaymentSuccessfulAction =
					{
						type: DocumentsActionTypes.MAKE_PAYMENT_SUCCESSFUL,
						document: document
					};
				return dispatch(makePaymentSuccessfulAction);
			} catch (err) {
				const makePaymentFailedAction: MakePaymentFailedAction = {
					type: DocumentsActionTypes.MAKE_PAYMENT_FAILED
				};
				dispatch(makePaymentFailedAction);
				return Promise.reject(err);
			}
		};
	},
	updateDocumentPoDetails: (payload: UpdatePoDetailsPayload) => {
		return async (dispatch: Dispatch): Promise<boolean> => {
			const UpdateDocumentPoDetailsRequestedAction: UpdateDocumentPoDetailsRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_REQUESTED
				};
			dispatch(UpdateDocumentPoDetailsRequestedAction);
			try {
				const { force_update_external_editor } = await updatePoDetails(
					payload
				);
				const documentPaymentSuccessfulAction: UpdateDocumentPoDetailsSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_SUCCESSFUL,
						poNumber: payload.po_number
					};
				dispatch(documentPaymentSuccessfulAction);
				return force_update_external_editor;
			} catch (error) {
				const updateDocumentPoDetailsFailedAction: UpdateDocumentPoDetailsFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_PO_DETAILS_FAILED
					};
				dispatch(updateDocumentPoDetailsFailedAction);

				return Promise.reject(error);
			}
		};
	},
	bulkAssignSignatureBlocks: (
		bulkAssignSignatureBlocksRequest: BulkAssignSignatureBlocksRequest,
		documentId: string
	) => {
		return async (
			dispatch: Dispatch
		): Promise<BulkAssignSignatureBlocksSuccessfulAction> => {
			const bulkAssignSignatureBlocksRequestedAction: BulkAssignSignatureBlocksRequestedAction =
				{
					type: DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_REQUESTED
				};

			dispatch(bulkAssignSignatureBlocksRequestedAction);

			try {
				const response = await bulkAssignSignatureBlocks(
					bulkAssignSignatureBlocksRequest,
					documentId
				);

				const bulkAssignSignatureBlocksSuccessfulAction: BulkAssignSignatureBlocksSuccessfulAction =
					{
						type: DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_SUCCESSFUL,
						document: response
					};

				return dispatch(bulkAssignSignatureBlocksSuccessfulAction);
			} catch (error) {
				console.error(error);

				const bulkAssignSignatureBlocksFailedAction: BulkAssignSignatureBlocksFailedAction =
					{
						type: DocumentsActionTypes.BULK_ASSIGN_SIGNATURE_BLOCK_FAILED
					};
				return Promise.reject(bulkAssignSignatureBlocksFailedAction);
			}
		};
	},
	updatePreviewPaymentSummaryDetails: (
		showPaymentSummary: boolean | null,
		showPaymentTerms: boolean | null
	) => {
		return (dispatch: Dispatch): UpdatePreviewPaymentSummaryAction => {
			const updatePreviewPaymentSummaryDetailsAction: UpdatePreviewPaymentSummaryAction =
				{
					type: DocumentsActionTypes.UPDATE_PREVIEW_PAYMENT_SUMMARY,
					showPaymentSummary,
					showPaymentTerms
				};
			return dispatch(updatePreviewPaymentSummaryDetailsAction);
		};
	},
	createCheckoutSession: (
		documentId: string,
		gateway: Gateway,
		paymentMethod: PaymentMethod
	) => {
		return async (dispatch: Dispatch): Promise<string> => {
			try {
				const createCheckoutSessionRequestedAction: CreateCheckoutSessionRequestedAction =
					{
						type: DocumentsActionTypes.STRIPE_CHECKOUT_SESSION_REQUESTED
					};
				dispatch(createCheckoutSessionRequestedAction);
				const url = await createCheckoutSession(
					documentId,
					paymentMethod,
					gateway
				);
				return url;
			} catch (error) {
				const createCheckoutSessionFailedAction: CreateCheckoutSessionFailedAction =
					{
						type: DocumentsActionTypes.STRIPE_CHECKOUT_SESSION_FAILED
					};
				dispatch(createCheckoutSessionFailedAction);
				return Promise.reject(error);
			}
		};
	},
	quickbooksSyncDrawerOpened: () => {
		return (dispatch: Dispatch): QuickbooksSyncDrawerOpenedAction => {
			const quickbooksSyncDrawerOpenedAction: QuickbooksSyncDrawerOpenedAction =
				{
					type: DocumentsActionTypes.QUICKBOOKS_SYNC_DRAWER_OPENED
				};
			return dispatch(quickbooksSyncDrawerOpenedAction);
		};
	},
	quickbooksSyncDrawerClosed: () => {
		return (dispatch: Dispatch): QuickbooksSyncDrawerClosedAction => {
			const quickbooksSyncDrawerClosedAction: QuickbooksSyncDrawerClosedAction =
				{
					type: DocumentsActionTypes.QUICKBOOKS_SYNC_DRAWER_CLOSED
				};
			return dispatch(quickbooksSyncDrawerClosedAction);
		};
	},

	quickbooksSyncMetadata: (documentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<QuickbooksSyncMetadataSuccessfulAction> => {
			const quickbooksSyncMetadataRequested: QuickbooksSyncMetadataRequestedAction =
				{
					type: DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_REQUESTED
				};
			dispatch(quickbooksSyncMetadataRequested);
			try {
				const quickbooksMetadata = await getQuickbooksSyncMetadata(
					documentId
				);
				const quickbooksSyncMetadataSuccessful: QuickbooksSyncMetadataSuccessfulAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_SUCCESSFUL,
						metadata: quickbooksMetadata
					};
				return dispatch(quickbooksSyncMetadataSuccessful);
			} catch (error) {
				const quickbooksSyncMetadataFailed: QuickbooksSyncMetadataFailedAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_FORM_METADATA_FAILED
					};
				dispatch(quickbooksSyncMetadataFailed);
				return Promise.reject(error);
			}
		};
	},
	quickbooksSyncFormdata: (payload: QuickbooksSyncFormDataParams) => {
		return async (
			dispatch: Dispatch
		): Promise<QuickbooksSyncFormdataSuccessfulAction> => {
			const quickbooksSyncMetadataRequested: QuickbooksSyncFormdataRequestedAction =
				{
					type: DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_REQUESTED
				};
			dispatch(quickbooksSyncMetadataRequested);
			try {
				await quickbooksFormSyncData(payload);
				const quickbooksSyncMetadataSuccessful: QuickbooksSyncFormdataSuccessfulAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_SUCCESSFUL
					};
				return dispatch(quickbooksSyncMetadataSuccessful);
			} catch (error) {
				const quickbooksSyncMetadataFailed: QuickbooksSyncFormdataFailedAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_FORMDATA_SYNC_FAILED
					};
				dispatch(quickbooksSyncMetadataFailed);
				return Promise.reject(error);
			}
		};
	},
	getQuickbooksCustomers: (searchString: string) => {
		return async (
			dispatch: Dispatch
		): Promise<QuickbooksCustomersSuccessfulAction> => {
			const quickbooksCustomersRequested: QuickbooksCustomersRequestedAction =
				{
					type: DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_REQUESTED
				};
			dispatch(quickbooksCustomersRequested);
			try {
				const quickbooksCustomersResponse =
					await getQuickbooksCustomers(searchString);
				const quickbooksCustomersSuccessful: QuickbooksCustomersSuccessfulAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_SUCCESSFUL,
						customers: quickbooksCustomersResponse.customers
					};
				return dispatch(quickbooksCustomersSuccessful);
			} catch (error) {
				const quickbooksCustomersFailed: QuickbooksCustomersFailedAction =
					{
						type: DocumentsActionTypes.QUICKBOOKS_CUSTOMERS_FAILED
					};
				dispatch(quickbooksCustomersFailed);
				return Promise.reject(error);
			}
		};
	},
	expireCurrentStripeCheckoutSession: (documentId: string) => {
		return async (
			dispatch: Dispatch
		): Promise<ExpireCurrentCheckoutSessionSuccessfulAction> => {
			try {
				const expireCurrentCheckoutSessionRequestedAction: ExpireCurrentCheckoutSessionRequestedAction =
					{
						type: DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_REQUESTED
					};
				dispatch(expireCurrentCheckoutSessionRequestedAction);
				await expireCurrentStripeCheckoutSession(documentId);
				const expireCurrentCheckoutSessionSuccessfulAction: ExpireCurrentCheckoutSessionSuccessfulAction =
					{
						type: DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_SUCCESSFUL
					};
				return dispatch(expireCurrentCheckoutSessionSuccessfulAction);
			} catch (err) {
				const expireCurrentCheckoutSessionFailedAction: ExpireCurrentCheckoutSessionFailedAction =
					{
						type: DocumentsActionTypes.EXPIRE_CURRENY_CHECKOUT_SESSION_FAILED
					};
				dispatch(expireCurrentCheckoutSessionFailedAction);
				return Promise.reject(err);
			}
		};
	},

	updateOrderFormPublishStatus: (
		updateOrderFormPublishStatusRequest: UpdateOrderFormPublishStatusRequest,
		documentId: string
	) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateOrderFormPublishStatusSuccessfulAction> => {
			const updateOrderFormPublishStatusRequestedAction: UpdateOrderFormPublishStatusRequestedAction =
				{
					type: DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_REQUESTED
				};

			dispatch(updateOrderFormPublishStatusRequestedAction);

			try {
				const currentDocument = await updateOrderFormPublishStatus(
					updateOrderFormPublishStatusRequest,
					documentId
				);

				if (currentDocument) {
					const updateOrderFormPublishStatusSuccessfulAction: UpdateOrderFormPublishStatusSuccessfulAction =
						{
							type: DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_SUCCESSFUL,
							documentStatus:
								updateOrderFormPublishStatusRequest.document_status
						};

					return dispatch(
						updateOrderFormPublishStatusSuccessfulAction
					);
				} else return Promise.reject("Current document not found");
			} catch (error) {
				const updateOrderFormPublishStatusFailedAction: UpdateOrderFormPublishStatusFailedAction =
					{
						type: DocumentsActionTypes.UPDATE_ORDER_FORM_PUBLISH_STATUS_FAILED
					};

				dispatch(updateOrderFormPublishStatusFailedAction);

				return Promise.reject(error);
			}
		};
	},

	updateDocumentLinkStatus: (
		updateDocumentLinkStatusRequest: UpdateDocumentLinkStatusRequest,
		documentId: string
	) => {
		return async (
			dispatch: Dispatch
		): Promise<UpdateDocumentLinkStatusSuccessfulAction> => {
			try {
				await updateDocumentStatusLink(
					updateDocumentLinkStatusRequest,
					documentId
				);
				const updateOrderFormPublishStatusFailedAction: UpdateDocumentLinkStatusSuccessfulAction =
					{
						type: DocumentsActionTypes.UPDATE_DOCUMENT_LINK_STATUS_SUCCESSFULL
					};
				return dispatch(updateOrderFormPublishStatusFailedAction);
			} catch (error) {
				return Promise.reject(error);
			}
		};
	},

	updateDocumentPaymentSummary: (paymentSummary: PaymentSummary | null) => {
		return (
			dispatch: Dispatch
		): UpdateCurrentDocPaymentSummarySuccessfulAction => {
			const updateCurrentDocPaymentSummarySuccessfulAction: UpdateCurrentDocPaymentSummarySuccessfulAction =
				{
					type: DocumentsActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL,
					paymentSummary
				};
			return dispatch(updateCurrentDocPaymentSummarySuccessfulAction);
		};
	},

	downloadDocumentLogs: (
		DownloadDocumentLogsRequest: DownloadDocumentLogsRequest
	) => {
		return async (
			dispatch: Dispatch
		): Promise<DownloadDocumentLogsSuccessfulAction> => {
			const downloadDocumentProductListRequestedAction: DownloadDocumentLogsRequestedAction =
				{
					type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_REQUESTED
				};
			dispatch(downloadDocumentProductListRequestedAction);
			try {
				const response = await downloadDocumentLogs(
					DownloadDocumentLogsRequest.documentId,
					DownloadDocumentLogsRequest.logs
				);
				const downloadDocumentSignatureLogSuccessfulAction: DownloadDocumentLogsSuccessfulAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_SUCCESSFUL
					};
				let fileName = response.fileName;
				if (!fileName) {
					const ext = extension(response.fileData.type);
					fileName = [
						DownloadDocumentLogsRequest.downloadedFileName,
						ext
					].join(".");
				}
				DownloadFile(response.fileData, fileName);
				return dispatch(downloadDocumentSignatureLogSuccessfulAction);
			} catch (error) {
				const downloadDocumentSignatureLogFailedAction: DownloadDocumentLogsFailedAction =
					{
						type: DocumentsActionTypes.DOWNLOAD_DOCUMENT_LOGS_FAILED
					};
				dispatch(downloadDocumentSignatureLogFailedAction);

				return Promise.reject(error);
			}
		};
	},

	showPreviewDocumentModal: () => {
		return (dispatch: Dispatch): ShowPreviewDocumentModalAction => {
			const showPreviewDocumentModalAction: ShowPreviewDocumentModalAction =
				{
					type: DocumentsActionTypes.SHOW_PREVIEW_DOCUMENT_MODAL
				};
			return dispatch(showPreviewDocumentModalAction);
		};
	},
	hidePreviewDocumentModal: () => {
		return (dispatch: Dispatch): HidePreviewDocumentModalAction => {
			const hidePreviewDocumentModalAction: HidePreviewDocumentModalAction =
				{
					type: DocumentsActionTypes.HIDE_PREVIEW_DOCUMENT_MODAL
				};
			return dispatch(hidePreviewDocumentModalAction);
		};
	},
	showPreviewDocumentAsPdfModal: () => {
		return (dispatch: Dispatch): ShowPreviewDocumentAsPdfModalAction => {
			const showPreviewDocumentAsPdfModalAction: ShowPreviewDocumentAsPdfModalAction =
				{
					type: DocumentsActionTypes.SHOW_PREVIEW_DOCUMENT_AS_PDF_MODAL
				};
			return dispatch(showPreviewDocumentAsPdfModalAction);
		};
	},
	hidePreviewDocumentAsPdfModal: () => {
		return (dispatch: Dispatch): HidePreviewDocumentAsPdfModalAction => {
			const hidePreviewDocumentAsPdfModalAction: HidePreviewDocumentAsPdfModalAction =
				{
					type: DocumentsActionTypes.HIDE_PREVIEW_DOCUMENT_AS_PDF_MODAL
				};
			return dispatch(hidePreviewDocumentAsPdfModalAction);
		};
	},
	updateBlockList:
		(blockList: string[]) =>
		async (
			dispatch: ThunkDispatch<GlobalState, any, Action>,
			getState: () => GlobalState
		): Promise<void> => {
			const currentDocument = getState().documents.currentActiveDocument;

			if (!currentDocument) {
				throw new Error("No active document found");
			}

			try {
				const updatedDocument = await updateRevisionBlockList({
					blockList,
					documentId: currentDocument.id
				});

				dispatch({
					type: DocumentsActionTypes.UPDATE_CURRENT_DOCUMENT_SUCCESSFUL,
					updateCurrentDocument: updatedDocument
				});

				const latestRevision =
					Document.getLatestRevision(updatedDocument);
				const blocks = latestRevision?.blocks?.data || [];

				const blockMapper = blocks.reduce(
					(tempObj: BlockMapper, block: Block) => ({
						...tempObj,
						[block.id]: block
					}),
					{}
				);

				const updateBlockMapperSuccessfulAction = {
					type: BlocksActionTypes.UPDATE_BLOCK_MAPPER_SUCCESSFUL,
					blockMapper
				};
				proposalBuilderStore.dispatch(
					updateBlockMapperSuccessfulAction
				);
			} catch (error) {
				console.error("Error updating block list:", error);
				throw error;
			}
		},
	setAiCoverImageUrl: (url: string | null) => {
		return (dispatch: Dispatch): SetAiCoverImageUrlAction => {
			return dispatch({
				type: DocumentsActionTypes.SET_AI_COVER_IMAGE_URL,
				payload: url
			});
		};
	}
};

export default DocumentsActionCreators;
